export const LIVE_AMAZON_ADS_IMPORTED_AT = "2026-10-24T08:03:59.883Z";
export const LIVE_AMAZON_ADS_ROWS = [
  {
    "date": "2026-10-22",
    "adId": "A01584441SE7ETTCKXXO5",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-01",
    "asin": "B0HNV8HL1L",
    "name": "IR E27 Light Bulb Camera 1080P HD Wireless Wifi Smart Home Security Camera",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 9,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0158008ADHZ20YD500W",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-02",
    "asin": "B0HNVGY9J6",
    "name": "Scrub Brush With Long Handle, Floor Scrub Brush Squeegee Broom For Cleaning, 3 In 1 Shower Scrubber Floor Broom Squeegee For Concrete Tile Wall Deck Patio Grey",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 7,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100002AURGEN03",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-03",
    "asin": "B0HNV7LGRL",
    "name": "Facial And Neck Massager, Pink Neck Beauty Device",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 6,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100003AURGEN04B",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-04B",
    "asin": "B0HP5XHTV1",
    "name": "Wall-Mounted Bathroom & Entryway Storage Shelf Organizer Rack with 4 Utility Hooks (White)",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 5,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01579203QVORRLABJNZI",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-05",
    "asin": "B0HNV2D4JB",
    "name": "Bathroom Corner Shelf Organizer With Hooks, Easy To Install",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 4,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01574522BXC707ZLPYN",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-06",
    "asin": "B0HNTT8QNX",
    "name": "HD-1857-A 1.8L Electric Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 4,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0157272213SK0B179BXE",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-07A",
    "asin": "B0HNWZZSYH",
    "name": "Wall Mounted Bathroom Triangle Shower Caddy Shelf Organizer Rack, No-Drill Black Wire",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 3,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0157028VUNOMFU2EY81",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-08",
    "asin": "B0HNV7FBST",
    "name": "Punch-Free Wall Bathroom Corner Storage Rack & Kitchen Spice Organizer Shelf with Dual Mounts",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 3,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01565922QFMUHAYN67W7",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-09",
    "asin": "B0HNVCG365",
    "name": "Octagonal Crushed Crystal Mirrored Floating Wall Shelf Decorative Glass Display Sconce",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 2,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A015638088SNOC2P34W7",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-10",
    "asin": "B0HNVDRQMY",
    "name": "4-Tier Heavy Duty Rolling Storage Rack Organizer Shelf with Locking Caster Wheels",
    "price": 79.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 2,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01561363Q0RK91Q6J6J6",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-11",
    "asin": "B0HNVLB73H",
    "name": "316 Stainless Steel Cast Iron Chainmail Scrubber Brush with Ergonomic Silicone Handle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 1,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01557002AXCXWX38MQPV",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-12",
    "asin": "B0HNVGMG34",
    "name": "7-in-1 Cordless Electric Spin Scrubber Cleaning Brush with Extendable 12-54\" Stainless Handle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 1,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01636482VHP7LJSHSOOB",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-13",
    "asin": "B0HNVBZFQ7",
    "name": "Handheld Cordless Electric Spin Scrubber Kitchen & Bathroom Power Cleaning Brush Kit",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01633362GH1G698ZF3XC",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-14",
    "asin": "B0HNV6W4FL",
    "name": "2-in-1 Long Handle Stiff Bristle Bathroom Floor Scrub Brush with Integrated Squeegee Scraper",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016315635KSA71Y85L6G",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-15",
    "asin": "B0HNV6F7F4",
    "name": "Multi-Surface Window Track, Sliding Door Groove & Tile Crevice Gap Cleaning Brush",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0162912128J1XCPKAU2X",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-16",
    "asin": "B0HNVD28P6",
    "name": "1.8L Borosilicate Glass & Brushed Stainless Cordless Electric Water Kettle (Series 16)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016232028O9IBLGIOZW",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-17",
    "asin": "B0HNVRSY2X",
    "name": "Shower Niche Ready For Tile 16x16 Inch Recessed Wall Bathroom Shelf Organizer (Matte Black)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01621081XSWKNVRTD9MG",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-18",
    "asin": "B0HNVXPYM1",
    "name": "4-Tier Heavy-Duty Closet & Bathroom Shelf Storage Organizer Rack",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0161864272R5JYHK66Q4",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-19",
    "asin": "B0HNW2PKKQ",
    "name": "Long-Handle Cordless Electric Bath & Shower Spin Scrubber with Massage Heads",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016142831O011M2G97X5",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-20",
    "asin": "B0HNVSZJCY",
    "name": "Food-Grade Silicone Farm Fresh Egg Scrubber & Rotary Kitchen Cleaning Brush",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016118434M170F9HI7ZO",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-21",
    "asin": "B0HNVTVYX9",
    "name": "Multi-Size Stainless Steel & Nylon Straw, Bottle & Espresso Tube Cleaning Brush Set (10-Pack)",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016097212Z1ARXKRS4HC",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-22",
    "asin": "B0HNVV1CQH",
    "name": "Curved V-Shape Rim & Corner Gap Toilet & Tile Crevice Scrub Brush (3-Pack)",
    "price": 21.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01606363V56LINVRZX3Z",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-24",
    "asin": "B0HNW3SVRX",
    "name": "Heated Electric Shiatsu Neck, Back & Shoulder Kneading Massage Pillow (Home & Car)",
    "price": 79.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01601363NDMPFB3N0ZQ0",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-25",
    "asin": "B0HNW3YXL2",
    "name": "360° Deep-Tissue 6-Wheel Cervical Neck & Shoulder Trigger Point Massage Roller",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A015145239U77BZQ1337L",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-27",
    "asin": "B0HNVRJ9MJ",
    "name": "Floating Bathroom Wall Shelves with Towel Bar & Guardrail (Matte Black, Set of 2)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100025AURGEN28A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-28A",
    "asin": "B0HP5TR9Z6",
    "name": "Under Sink 2-Tier Sliding Drawer Cabinet Organizer Rack with Hanging Hooks & Divider Baskets",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01509281KOQH3ORG2T06",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-29",
    "asin": "B0HNVT1MNQ",
    "name": "Magnetic Stove Top Shelf 30-Inch Stainless Steel Kitchen Spice Storage Organizer",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0150716F7U00TP2L4XR",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-30",
    "asin": "B0HNVWBH7N",
    "name": "Over The Toilet Storage Shelf 3-Tier Freestanding Bathroom Space Saver Organizer",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01506283VEMQD0Z0E13Q",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-31",
    "asin": "B0HNVRW2W5",
    "name": "Heavy-Duty Over The Door Pantry Organizer Shelf Rack (6 Deep Baskets, White)",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01501921I6PGSY77D8S7",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-32",
    "asin": "B0HNVTXS6H",
    "name": "Acrylic Floating Wall Bookshelves 15-Inch Clear Display Ledge Shelves (Set of 4)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100030AURGEN33A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-33A",
    "asin": "B0HP5X1TST",
    "name": "Desktop Dual Monitor Stand Riser with Storage Shelf & Phone Slot (Black Wood)",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01496361EQS8FB16XV84",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-34",
    "asin": "B0HNW1PNNG",
    "name": "Adhesive Shower Caddy Basket Corner Wall Shelf (Rustproof SUS304 Stainless Steel)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A014945637VAC6RI68HAQ",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-35",
    "asin": "B0HNVRY5C8",
    "name": "Pull Out Kitchen Cabinet Organizer Sliding Wire Storage Shelf 14-Inch Deep",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100033AURGEN36A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-36A",
    "asin": "B0HNWMVT5N",
    "name": "Wall-Mounted Bathroom & Entryway Corner Shelf Organizer with 4 Hanging Hooks (Matte White)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100034AURGEN37A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-37A",
    "asin": "B0HNWTQ8F2",
    "name": "Extendable Long-Handle Spin Scrubber Cleaning Brush with 8 Replaceable Brush Heads",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01487202327TO4M3YCR2",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-38",
    "asin": "B0HNVTJX2C",
    "name": "Hard-Bristle Tile Grout Cleaning Brush with Ergonomic Angled Grip (Set of 3)",
    "price": 14.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0148252ELVR1HSMGEUD",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-39",
    "asin": "B0HNVZDZLJ",
    "name": "Silicone Toilet Brush and Holder Set with Wall Mount & Soft Flexible Bristles",
    "price": 18.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01481643TV6WEABL6IX4",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-40",
    "asin": "B0HNVVCJ8M",
    "name": "Multi-Function Window Track & Door Groove Crevice Cleaning Brush (Set of 3)",
    "price": 12.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100038AURGEN41A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-41A",
    "asin": "B0HNWRTYBG",
    "name": "Long Bottle Brush & Narrow Straw Cleaner Wand Set with Nylon Bristles (10-Pack)",
    "price": 15.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01478286PL3Y0MXZNF1",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-42",
    "asin": "B0HNVZBFC1",
    "name": "Dish Soap Dispensing Palm Brush with Storage Stand (Leak-Free Push Button)",
    "price": 16.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01475162HJAWRSU3DPZA",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-43",
    "asin": "B0HNVTQWNB",
    "name": "Window Blind Duster & Air Conditioner Shutter Cleaner Brush with 5 Microfiber Sleeves",
    "price": 13.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100041AURGEN44A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-44A",
    "asin": "B0HNWN5YX7",
    "name": "Stiff Bristle Scrub Brush with Built-In Squeegee Edge for Tile, Grout & Shower Floors",
    "price": 14.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0155308BFXJIPO8BYRJ",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-45",
    "asin": "B0HNVTXP58",
    "name": "Wire-Free Steam Grill Cleaning Brush with Heat-Resistant Scrubber Foam Pads",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A015512816KPKANFJ2FLD",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-46",
    "asin": "B0HNVRQ3CV",
    "name": "2-in-1 Floor Scrub Brush with Stiff Bristles & Built-in Rubber Squeegee (54-Inch)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01546287PX67LJJMGJL",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-47",
    "asin": "B0HNVT9B4C",
    "name": "Heated Neck & Shoulder Wrap Massager with Soothing Vibration Therapy (USB)",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01545722ECI45WISEGQ8",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-48",
    "asin": "B0HNVSZQXK",
    "name": "Mini Deep-Tissue Muscle Percussion Massage Gun with 4 Heads (Type C Rechargeable)",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100046AURGEN49A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-49A",
    "asin": "B0HP5T5GP9",
    "name": "6-Wheel Cervical Spine Pressure Point Neck Roller Manual Massager (Pink)",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01538921MV2SVRONN85T",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-50",
    "asin": "B0HNVTGJDQ",
    "name": "Silicone Scalp Shampoo Massager & Scalp Care Shower Brush (2-Pack)",
    "price": 13.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100048AURGEN51",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-51",
    "asin": "B0HNW1XZDX",
    "name": "Smart Heated Eye Massager with Gentle Air Compression & Bluetooth Music (White)",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01538362EPDJE01OW6JL",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-52",
    "asin": "B0HNVT3FKJ",
    "name": "Dual Foot Reflexology Textured Comfort Roller & Arch Comfort Relief Massager",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01534003CSQQ4LYG9XMU",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-53",
    "asin": "B0HNVQJ3RG",
    "name": "360-Degree Muscle Roller Stick for Legs, Calves, Quads & Hamstrings (Black) – Body & Muscle Massager",
    "price": 21.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100051AURGEN54",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-54",
    "asin": "B0HNVYDMCT",
    "name": "Heated Knee Joint Massager with Vibration & Thermal Compression Brace (Cordless)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100052AURGEN55",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-55",
    "asin": "B0HNVRKLCM",
    "name": "Ergonomic Hand & Palm Compression Massager with Heat for Hand Comfort Relief",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0153312HUKY3OKT1F6D",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-57",
    "asin": "B0HNW3XGD8",
    "name": "Under Cabinet Mug Holder Hanging Wine Glass & Coffee Cup Rack (Set of 3, Black)",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100054AURGEN58",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-58",
    "asin": "B0HNVR97HR",
    "name": "Over Sink Dish Drying Rack with Utensil Holder & Sponge Tray (Stainless Steel)",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01530003BBDUQA17L7TN",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-59",
    "asin": "B0HNVXTYF5",
    "name": "Corner Tension Pole Shower Caddy 4-Tier Adjustable 5 to 9 Feet (Matte Black)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01583443QKKRL763ZERH",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-60",
    "asin": "B0HNVRXYNH",
    "name": "Foldable Wall Mounted Clothes Drying Rack Space-Saving Laundry Hanger (White)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01581642OC443DCLKWJJ",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-61",
    "asin": "B0HNVSY54X",
    "name": "Magnetic Refrigerator Spice Rack & Paper Towel Holder (Set of 4, Matte Black)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A015760816M9DHR727T6",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-62",
    "asin": "B0HNVVSS4C",
    "name": "Clear Acrylic Floating Wall Display Shelves 24-Inch with Front Lip (Set of 2)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01574283GEWHAW5WLR9N",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-63",
    "asin": "B0HNVV5GT3",
    "name": "Under Desk Cable Management Tray Wire Organizer Shelf (No-Drill Clamp Mount)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01569282YRH8ECXI0BO1",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-64",
    "asin": "B0HNVRQKR9",
    "name": "Expandable Kitchen Cabinet Shelf Organizer Riser (Set of 2, Bamboo & Metal)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01567163Q7SQEE8KULCE",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-65",
    "asin": "B0HNVQJQ3K",
    "name": "Wall Mounted Wine Rack with Stemware Glass Holder Shelf (Holds 5 Bottles)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01561922AKCI17DVRDM2",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-66",
    "asin": "B0HNVR8X81",
    "name": "Shower Caddy Basket Corner Shelves with Razor Hooks (Pack of 2, Matte Black SUS304)",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0155980G8WB4TZWI33C",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-67",
    "asin": "B0HNVWS253",
    "name": "Desktop Bookshelf Mini Tabletop Countertop Storage Organizer Display Shelf",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01637362QBDGD55TDCV0",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-68",
    "asin": "B0HNVYJFZ7",
    "name": "Sliding Cabinet Basket Organizer 2-Tier Stackable Storage Drawers (White Mesh)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01634928NF57KIN9WEF",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-69",
    "asin": "B0HNVSV8C6",
    "name": "Wall Mounted Broom & Mop Holder Rack with 5 Grippers & 6 Utility Hooks",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016300024GBB10CFGZXH",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-70",
    "asin": "B0HNW59BGS",
    "name": "Magnetic Knife Strip 16-Inch Stainless Steel Wall Bar for Kitchen Utensils",
    "price": 23.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01627563UISO2NUUE7F2",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-71",
    "asin": "B0HNVRSP3G",
    "name": "Adjustable Pan & Pot Lid Organizer Rack (10 Modular Non-Scratch Dividers)",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01624201CC4ACZXPHA3I",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-72",
    "asin": "B0HNVT9B99",
    "name": "Electric Sonic Scrubber Power Cleaning Brush with 4 Interchangeable Heads",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01619202FIEW9NS6Y250",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-73",
    "asin": "B0HNVTX69Y",
    "name": "Long Handle Bath Tub & Tile Scrubber Brush with 180° Pivoting Head (48-Inch)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01617081MCFWCT6ITO4T",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-74",
    "asin": "B0HNVWTFD6",
    "name": "Silicone Bottle Brush Cleaner with Long Handle for Narrow-Neck Flasks & Tumblers",
    "price": 13.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0161528TG5X3KZWMT1F",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-75",
    "asin": "B0HNVS45J8",
    "name": "Pet Hair Detailer & Upholstery Lint Remover Brush for Couches, Rugs & Cars",
    "price": 16.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01610282653LJQV0DKV3",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-76",
    "asin": "B0HNVNL981",
    "name": "Keyboard & Earbud Deep Cleaning Brush Kit 7-in-1 Multifunction Cleaner Tool",
    "price": 14.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01608483L7N7LJMGXQZX",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-77",
    "asin": "B0HNW3WCYD",
    "name": "Car Interior Air Vent & Detail Cleaning Brushes with Soft Boar Hair (Set of 5)",
    "price": 17.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A016044812IISOJZU1BJC",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-78",
    "asin": "B0HNVXMZBK",
    "name": "Flexible Dryer Vent & Refrigerator Coil Cleaning Brush 30-Inch Lint Remover",
    "price": 15.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0160112EUPYOGQEV265",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-79",
    "asin": "B0HNVSQ2L3",
    "name": "Cast Iron Cleaner Chainmail Scrubber with Built-In Silicone Sponge Core",
    "price": 18.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100076AURGEN80A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-80A",
    "asin": "B0HNWZXTSW",
    "name": "Heavy-Duty Green Scouring Pad Scrub Sponge Brush with Ergonomic Handle for Stovetops & Tile",
    "price": 16.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01510523H4AZWC3MAONL",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-81",
    "asin": "B0HNVYVPTB",
    "name": "Coffee Grinder & Espresso Machine Cleaning Brush with Wood Handle & Spoon (2-Pack)",
    "price": 14.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01510283AIAM8RH6G2FR",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-82",
    "asin": "B0HNVYSJCL",
    "name": "Ceiling Fan Duster with 54-Inch Telescoping Pole & Washable Microfiber Head",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0150528EMKOP2LGXCDC",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-83",
    "asin": "B0HNVPYJ9L",
    "name": "Straw Cleaning Brush Set Extra-Long 12-Inch with Nylon Bristles (10-Pack)",
    "price": 9.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01503162E0N8LUDUN9ZN",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-84",
    "asin": "B0HNVT1MTM",
    "name": "Decanter & Wine Glass Foam Scrubber Flexible Cleaning Brush (Bendable 17-Inch)",
    "price": 15.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01500363UA4TS2LUSUGU",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-85",
    "asin": "B0HNVXLPFS",
    "name": "Shoe Sneaker Cleaning Brush with Hard Pig Bristles & Ergonomic Wood Handle",
    "price": 13.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A014979237BQX1I9H7D16",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-86",
    "asin": "B0HNVRL9H6",
    "name": "Stainless Steel Straw Cleaning Brush Set with Hanging Ring (Pack of 8)",
    "price": 8.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01495802IW5FHNQPD6FD",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-87",
    "asin": "B0HNVZ3CDH",
    "name": "Heated Shiatsu Back & Neck Massager Pillow with Deep Kneading Nodes (Car & Home)",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100084AURGEN88A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-88A",
    "asin": "B0HP5KJSWQ",
    "name": "Electric Head & Scalp Massager Cordless Waterproof with 4 Silicone Claw Kneaders",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01490562UITGVGY408F6",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-89",
    "asin": "B0HNW2G6VG",
    "name": "Heated Hand Massager Machine with Air Pressure & Heat for Hand Comfort & Wrist Relaxation",
    "price": 56.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01488442C8PURXDKWBHN",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-90",
    "asin": "B0HNVVP6WB",
    "name": "Percussion Massage Gun for Athletes Deep Tissue Muscle Fascia Gun with 6 Heads",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100087AURGEN91",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-91",
    "asin": "B0HNVT61W8",
    "name": "Heated Leg Air Compression Massager for Circulation & Restless Leg Relief (Pair)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A014840834CBUEO5N9O7S",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-92",
    "asin": "B0HNVVC18J",
    "name": "Vibrating Foam Roller High-Intensity 4-Speed Deep Muscle Recovery Roller – Body & Muscle Massager",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A014832010NDOCTFMYTM8",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-94",
    "asin": "B0HNVQP451",
    "name": "Heated Eye Mask for Dry Eyes Warm Steam Compress with Smart Digital Timer (Grey)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100090AURGEN95A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-95A",
    "asin": "B0HP5J3XR8",
    "name": "Trigger Point Massage Ball Set Lacrosse Balls for Deep Tissue Myofascial Release",
    "price": 16.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0147672VD40YAPRPXYG",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-96",
    "asin": "B0HNVT87JH",
    "name": "Gua Sha Facial Tool & Jade Roller Set Natural Rose Quartz Face Massager (Pink)",
    "price": 18.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A0155464EU0ILPWQAF9N",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-97",
    "asin": "B0HNVTZ957",
    "name": "Heated Lumbar Support Belt Massage Wrap for Lower Back & Lower Back Comfort Relief",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01550283DDX7Q3KSCWJF",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-98",
    "asin": "B0HNVRRPJP",
    "name": "Manual Scalp Tingler Head Massager Scratch-Free Steel Wire Claws (2-Pack)",
    "price": 9.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01549722IG4VA4QYRRV8",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-99",
    "asin": "B0HNVRFQ3R",
    "name": "Body Smoothing Body Massager Brush Silicone Body Contouring & Skin Toning Mitt",
    "price": 12.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01547282NK9G13501KP",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-100",
    "asin": "B0HNVNYTBN",
    "name": "Heated Shoulder & Rotator Cuff Massager Wrap with Vibration Therapy (Cordless)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01542923F9HDBKBSFA1R",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-101",
    "asin": "B0HNVVYVS2",
    "name": "Textured Comfort Mat and Pillow Set for Back & Neck Soothing Comfort & Muscle Relaxation – Body & Muscle Massager",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01542361GAOA18GMBEJW",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-102A",
    "asin": "B0HNWMBNYR",
    "name": "Rapid-Boil 1.8L Borosilicate Glass & Stainless Steel Electric Water Kettle (Auto Shut-Off)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01537363PYPD4SYWNIWW",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-103",
    "asin": "B0HNW4XD1K",
    "name": "Electric Glass Tea Kettle 1.8L with Blue LED Light & Rapid Boil Protection",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A015355622CUWJPCAZB8Q",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-104A",
    "asin": "B0HNWMCH69",
    "name": "Smart Temperature Control Borosilicate Glass Electric Tea Kettle & Infuser (1.8L)",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100100AURGEN105",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-105",
    "asin": "B0HNVVSZDY",
    "name": "Portable Electric Kettle Small Travel Heating Mug for Water, Coffee & Tea (350ml)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-22",
    "adId": "A01531563V314L116LAM5",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-106A",
    "asin": "B0HNWLVB3N",
    "name": "1.8L Fast-Boil Glass & Black Stainless Steel Electric Tea Kettle with Boil-Dry Protection",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100102AURGEN107",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-107",
    "asin": "B0HNWZMCVS",
    "name": "3-Tier Countertop Spice Rack Organizer Stand with Protective Guardrails (Matte Black)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100103AURGEN108",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-108",
    "asin": "B0HNWZ7TSB",
    "name": "Over-The-Toilet Storage Cabinet Rack 3-Tier Bathroom Space Saver Shelf (Black Steel)",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100104AURGEN109",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-109",
    "asin": "B0HNWNL453",
    "name": "Pull-Out Under Cabinet Pot & Pan Lid Organizer Rack Sliding Bakeware Divider",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100105AURGEN110A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-110A",
    "asin": "B0HP5DWQJ3",
    "name": "Wall Mounted Coat Rack Shelf with 8 Double Hooks & Floating Display Ledge (Rustic Walnut)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100106AURGEN111A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-111A",
    "asin": "B0HP5DXCJ8",
    "name": "Heavy-Duty Garage Wall Shelving 2-Pack 2x4ft Steel Storage Rack (400 lb Capacity)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100107AURGEN112",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-112",
    "asin": "B0HNWSLGM8",
    "name": "2-Tier Lazy Susan Turntable Spice & Condiment Organizer Rack (12-Inch Stainless)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100108AURGEN113",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-113",
    "asin": "B0HNWV5ZK6",
    "name": "No-Drill Suction Cup Shower Caddy Shelf Basket Set of 2 (Matte Black Aluminum)",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100109AURGEN114",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-114",
    "asin": "B0HNWSLRXF",
    "name": "5-Tier Corner Bookshelf Industrial Freestanding Plant & Display Rack (Black & Oak)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100110AURGEN115",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-115",
    "asin": "B0HNWXGHZL",
    "name": "Expandable Microwave Oven Rack 2-Tier Countertop Kitchen Appliance Shelf with Hooks",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100111AURGEN116",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-116",
    "asin": "B0HNWY2B1Q",
    "name": "Wall Mounted Wine Rack & Stemware Glass Holder Floating Bar Shelf (Matte Black)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100112AURGEN117",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-117",
    "asin": "B0HNWXHM1C",
    "name": "Slim 4-Tier Rolling Utility Cart Narrow Laundry & Bathroom Gap Storage Rack (6-Inch Wide)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100113AURGEN118",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-118",
    "asin": "B0HNWZJDBW",
    "name": "Over-The-Door Pantry Organizer 8-Tier Heavy-Duty Metal Spice & Can Rack (Black)",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100114AURGEN119",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-119",
    "asin": "B0HNWRVDXR",
    "name": "Dual Monitor Stand Riser Length-Adjustable Desk Shelf Organizer with Storage Drawer",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100115AURGEN120A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-120A",
    "asin": "B0HP5BKMJM",
    "name": "3-Tier Hanging Closet Shelf Organizer Collapsible Sweater & Handbag Cubby Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100116AURGEN121A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-121A",
    "asin": "B0HP5KQL7B",
    "name": "Wall Mounted Hair Dryer & Styling Tool Organizer Shelf with Heatproof Steel Cups",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100117AURGEN122",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-122",
    "asin": "B0HNWVNV3C",
    "name": "Stackable Shoe Rack 4-Tier Entryway Metal Mesh Footwear Storage Shelf (Holds 16 Pairs)",
    "price": 33.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100118AURGEN123",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-123",
    "asin": "B0HNX2TR41",
    "name": "Under Shelf Hanging Wire Storage Basket Slide-In Pantry & Cabinet Rack (Set of 4)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100119AURGEN124",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-124",
    "asin": "B0HNWXHM1F",
    "name": "Floating Corner Wall Shelves Set of 4 L-Shaped Wood & Matte Black Metal Brackets",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100120AURGEN125",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-125",
    "asin": "B0HNWYCZCR",
    "name": "Water Bottle Organizer Rack 4-Tier Stackable Tumbler & Travel Mug Cabinet Shelf",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100121AURGEN126",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-126",
    "asin": "B0HNX212HT",
    "name": "Wall Mounted Broom & Mop Holder Garage Garden Tool Organizer Rack (5 Slots, 6 Hooks)",
    "price": 23.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100122AURGEN127",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-127",
    "asin": "B0HNX18TSB",
    "name": "2-Tier Countertop Fruit Basket Bowl Stand with Detachable Banana Hanger (Matte Black)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100123AURGEN128",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-128",
    "asin": "B0HNX144BL",
    "name": "Adjustable Bakeware & Cutting Board Divider Rack 10-Compartment Cabinet Shelf",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100124AURGEN129A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-129A",
    "asin": "B0HP54V56S",
    "name": "Wall Mounted Towel Rack for Rolled Bath Towels 3-Tier Spa Bathroom Storage Shelf",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100125AURGEN130",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-130",
    "asin": "B0HNWXS7ZD",
    "name": "Coffee Pod Drawer & Mug Tree Countertop Coffee Station Organizer Shelf (2-Tier)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100126AURGEN131A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-131A",
    "asin": "B0HP5MN559",
    "name": "Heavy-Duty Cast Iron Skillet Rack 5-Tier Dutch Oven & Griddle Storage Stand – Storage Shelf Organizer",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100127AURGEN132",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-132",
    "asin": "B0HNWXBQND",
    "name": "Clamp-On Desk Shelf Organizer 2-Tier Above/Below Desktop Gaming & Office Rack",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100128AURGEN133",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-133",
    "asin": "B0HNWQQ1K6",
    "name": "Can Organizer Dispenser Rack for Pantry 3-Tier Stackable Rolling Soda & Soup Shelf",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100129AURGEN134",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-134",
    "asin": "B0HNX1CTPS",
    "name": "Rustic Wood & Iron Pipe Wall Shelf 2-Tier Industrial Bathroom & Kitchen Bookcase",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100130AURGEN135",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-135",
    "asin": "B0HNWXSR26",
    "name": "Over Cabinet Door Trash Bag & Cutting Board Holder Under-Sink Storage Rack (Set of 2)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100131AURGEN136",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-136",
    "asin": "B0HNWSS1VX",
    "name": "Vinyl Record Wall Mount Display Ledge Shelves 6-Pack Clear Album Art Holders",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100132AURGEN137",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-137",
    "asin": "B0HNWL9232",
    "name": "3-Tier Window Plant Shelf Hanging Acrylic Indoor Herb & Succulent Display Rack",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100133AURGEN138A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-138A",
    "asin": "B0HP5MLKK7",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 138)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100134AURGEN139A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-139A",
    "asin": "B0HP5JNYTS",
    "name": "2-Tier Bathroom Vanity Countertop Tray Skincare, Perfume & Cosmetics Shelf (Black/Gold)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100135AURGEN140B",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-140B",
    "asin": "B0HP65M4NJ",
    "name": "Wall-Mounted Bathroom & Laundry Floating Storage Shelf Organizer Rack (Matte White · 140 Series)",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100136AURGEN141",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-141",
    "asin": "B0HNWYXG5Y",
    "name": "4-Tier Expandable Spice Drawer Organizer Tray Slanted Acrylic Cabinet Insert",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100137AURGEN142",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-142",
    "asin": "B0HNWZ37SB",
    "name": "Electric Spin Scrubber 9-in-1 Cordless Shower & Bathtub Cleaning Brush (IPX7 Waterproof)",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100138AURGEN143",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-143",
    "asin": "B0HNWXZQC3",
    "name": "Silicone Toilet Bowl Brush & Ventilated Quick-Dry Holder Set (2-Pack, Matte Black)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100139AURGEN144",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-144",
    "asin": "B0HNX1663X",
    "name": "Drill Brush Power Scrubber Attachment Kit 22-Piece Tile Grout, Tub & Auto Detailing Set",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100140AURGEN145",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-145",
    "asin": "B0HNWSK2TN",
    "name": "Long-Reach Microfiber Ceiling Fan & High Molding Cobweb Duster Brush (Extendable 100\")",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100141AURGEN146",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-146",
    "asin": "B0HNWRQZ93",
    "name": "Soap Dispensing Palm Dish Brush Set with Replaceable Bristle Heads & Drip Storage Stand",
    "price": 21.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100142AURGEN147A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-147A",
    "asin": "B0HP5NXDBT",
    "name": "Baseboard & Wall Cleaner Mop with 60\" Contoured Swivel Handle & 6 Washable Pads – Cleaning Scrub Brush",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100143AURGEN148",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-148",
    "asin": "B0HNWWYHFY",
    "name": "BBQ Grill Brush Bristle-Free Steam Cleaning Scraper with Stainless Chainmail Head",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100144AURGEN149",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-149",
    "asin": "B0HNX197ZH",
    "name": "Car Detailing Brush Kit 18-Piece Boar Hair Interior Vent, Wheel Rim & Engine Brushes",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100145AURGEN150",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-150",
    "asin": "B0HNWYYG87",
    "name": "Espresso Machine Group Head & Grinder Cleaning Brush Set (Walnut Handle, 5-Piece)",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100146AURGEN151",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-151",
    "asin": "B0HNWTMZQ8",
    "name": "Dryer Vent Cleaner Kit 30-Foot Flexible Lint Trap Brush & Vacuum Hose Attachment",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100147AURGEN152",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-152",
    "asin": "B0HNX61VXH",
    "name": "Reusable Pet Hair Remover Roller & Upholstery Carpet Fur Scraper Brush (Self-Cleaning)",
    "price": 23.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100148AURGEN153A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-153A",
    "asin": "B0HP5SWSWJ",
    "name": "Silicone Bottle Cleaning Brush Set Long-Handle Baby Bottle, Universal & Straw Cleaner",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100149AURGEN154",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-154",
    "asin": "B0HNX1GTFP",
    "name": "Heavy-Duty Deck & Concrete Wire Scrub Broom with 60\" Steel Handle (Moss & Algae Remover)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100150AURGEN155",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-155",
    "asin": "B0HNWWNTSZ",
    "name": "Magnetic Double-Sided Window Cleaner Brush for High-Rise Single-Glazed Glass (3–10mm)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100151AURGEN156A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-156A",
    "asin": "B0HP5GSFQW",
    "name": "Keyboard & Universal Cleaning Pen 8-in-1 Electronics Screen, Lens & Mechanical Keycap Brush",
    "price": 18.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100152AURGEN157A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-157A",
    "asin": "B0HP5GQV7Z",
    "name": "Natural Bamboo Dish Scrub Brush Set 6-Piece Cast Iron Pot, Vegetable & Bottle Scrubbers",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100153AURGEN158",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-158",
    "asin": "B0HNX212J6",
    "name": "Shower Glass Door Squeegee 12-Inch All-Black Stainless Steel with Adhesive Shower Hook",
    "price": 21.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100154AURGEN159",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-159",
    "asin": "B0HNWV2JRC",
    "name": "Grout & Crevice Cleaning Brush 6-Pack Hard-Bristle Tile Joint, Window Track & Sink Detailer",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100155AURGEN160",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-160",
    "asin": "B0HNWWZSM9",
    "name": "Golf Club Groove Cleaner Brush with Retractable Carabiner Clip & Water Squeeze Bottle",
    "price": 22.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100156AURGEN161",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-161",
    "asin": "B0HNWZZFX5",
    "name": "Microfiber Wheel & Tire Scrubbing Brush Set 5-Piece Bendable Alloy Rim & Lug Nut Cleaner",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100157AURGEN162",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-162",
    "asin": "B0HNWTQVMS",
    "name": "Window Blind Duster & AC Vent Cleaner Brush Set with 10 Washable Microfiber Sleeves",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100158AURGEN163A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-163A",
    "asin": "B0HP5TBXYH",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 163)",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100159AURGEN164",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-164",
    "asin": "B0HNWMV185",
    "name": "Record Player Anti-Static Carbon Fiber Vinyl Brush & Stylus Needle Cleaning Kit",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100160AURGEN165",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-165",
    "asin": "B0HNWLR5JQ",
    "name": "RV & Boat Telescoping Wash Brush 5-to-12 Foot Aluminum Pole with 5-Sided Soft Bristle Head",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100161AURGEN166",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-166",
    "asin": "B0HNX3TTBT",
    "name": "Suede & Nubuck Shoe Cleaning Brush 4-Way Brass/Nylon Bristle & Crepe Eraser Kit",
    "price": 19.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100162AURGEN167A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-167A",
    "asin": "B0HP5L6LM8",
    "name": "Pool Wall & Tile Algae Brush 18-Inch Curved Aluminum Back Swimming Pool Scrubber",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100163AURGEN168",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-168",
    "asin": "B0HNWR3ZNV",
    "name": "Radiator & Refrigerator Coil Cleaning Brush 36-Inch Flexible Long-Reach Lint Duster (2-Pack)",
    "price": 21.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100164AURGEN169",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-169",
    "asin": "B0HNWN5ZXT",
    "name": "Sonic Electric Makeup Brush Cleaner & Dryer Spinner Machine with 8 Silicone Collars",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100165AURGEN170",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-170",
    "asin": "B0HNWTYRNJ",
    "name": "Gutter Cleaning Tool from Ground 12-Foot Telescoping Roof Leaf Scoop & Scrub Brush",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100166AURGEN171",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-171",
    "asin": "B0HNX2T857",
    "name": "pizza Oven Brass Bristle Brush & Stainless Scraper with 42-Inch Detachable Wood Handle",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100167AURGEN172",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-172",
    "asin": "B0HNWRXH8S",
    "name": "Deep Tissue Percussion Muscle Massage Gun 30-Speed Quiet Brushless Motor with 10 Heads",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100168AURGEN173",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-173",
    "asin": "B0HNWYSL8Q",
    "name": "Heated Shiatsu Foot Massager Machine with Air Compression & Washable Fleece Liner",
    "price": 79.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100169AURGEN174A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-174A",
    "asin": "B0HP5V79BT",
    "name": "Cordless Electric Scalp & Head Massager Waterproof 4-Node Silicone Hair Growth Kneader",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100170AURGEN175",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-175",
    "asin": "B0HNWPWTNN",
    "name": "Heated Eye Massager with Bluetooth Music, Air Temple Compression & Foldable Band",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100171AURGEN176",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-176",
    "asin": "B0HNWT6RCN",
    "name": "Cordless Hand Massager with Heat & Air Compression for Hand Comfort & Wrist Relaxation Relief",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100172AURGEN177",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-177",
    "asin": "B0HNWYTGRR",
    "name": "Leg Compression Massager Boots for Circulation & Calf/Foot Recovery (6 Modes, 3 Heat Levels)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100173AURGEN178",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-178",
    "asin": "B0HNWZ2R1M",
    "name": "Mini Pocket Percussion Massage Gun Ultra-Light 0.9 lb Travel Muscle Reliever (Type C)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100174AURGEN179A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-179A",
    "asin": "B0HP5N5ZWW",
    "name": "Heated Knee Brace Massager Cordless Red Light & Vibration Joint Universal (Pair)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100175AURGEN180",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-180",
    "asin": "B0HNWWFNYR",
    "name": "Rose Quartz & Jade Facial Roller + Gua Sha Scraping Massage Tool Set (Luxury Gift Box)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100176AURGEN181A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-181A",
    "asin": "B0HP5NV4TB",
    "name": "Universal Cooling Ice Globe Facial Massager Wands Unbreakable Stainless Steel (Set of 2)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100177AURGEN182",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-182",
    "asin": "B0HNWVR16L",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 182)",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100178AURGEN183A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-183A",
    "asin": "B0HP5QW134",
    "name": "Wooden Foot Roller Massager 10-Row Textured Comfort Reflexology Arch Reliever",
    "price": 23.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100179AURGEN184A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-184A",
    "asin": "B0HP5QM2DM",
    "name": "High-Density Vibrating Foam Roller 5-Speed Rechargeable Myofascial Back Release Roller",
    "price": 56.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100180AURGEN185",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-185",
    "asin": "B0HNWT3RFL",
    "name": "Smart Cupping Therapy Massager Set 2-Pack Dynamic Red Light & Heated Suction Cups",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100181AURGEN186",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-186",
    "asin": "B0HNX33WZK",
    "name": "Stainless Steel Gua Sha Muscle Scraper IASTM Physical Therapy Fascia Release Tool",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100182AURGEN187A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-187A",
    "asin": "B0HP58L4JC",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 187)",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100183AURGEN188",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-188",
    "asin": "B0HNWYTRSM",
    "name": "Ergonomic S-Hook Trigger Point Cane Back & Shoulder Knot Textured Comfort Massager (11 Knobs)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100184AURGEN189A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-189A",
    "asin": "B0HP5NPZ5J",
    "name": "Sonic Silicone Facial Cleansing Brush & Heated Anti-Aging Massager (Waterproof Rechargeable)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100185AURGEN190",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-190",
    "asin": "B0HNWT724L",
    "name": "Cervical Neck Traction Pillow & Heated Gentle Pulse Pulse Stretcher for Tech-Neck Posture Relief",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100186AURGEN191",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-191",
    "asin": "B0HNWQDZ1T",
    "name": "Lumbar Support Pillow with Heated Vibration Massage for Office Chair & Car Driving",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100187AURGEN192A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-192A",
    "asin": "B0HP654X2M",
    "name": "Gooseneck Electric Pour-Over Kettle 1.0L with Variable PID Temperature Control (Matte Black) – Electric Kettle & Water Boiler",
    "price": 64.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100188AURGEN193",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-193",
    "asin": "B0HNWWZ422",
    "name": "Smart Glass Tea Maker Kettle 1.7L with Removable Stainless Infuser & 5 Steep Presets",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100189AURGEN194A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-194A",
    "asin": "B0HP5T558W",
    "name": "Foldable Silicone Travel Electric Kettle 0.6L Dual Voltage (110V/220V) with Carry Bag",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100190AURGEN195",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-195",
    "asin": "B0HNWXYXDY",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 195)",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100191AURGEN196A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-196A",
    "asin": "B0HP5JTS18",
    "name": "Portable Travel Electric Kettle 450ml Personal LCD Temperature Control Water Boiler Mug",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100192AURGEN197",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-197",
    "asin": "B0HNX18R7W",
    "name": "5.0L Instant Hot Water Dispenser & Countertop Boiler with 4 Temp Presets & Night Light",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100193AURGEN198A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-198A",
    "asin": "B0HP5KX1XB",
    "name": "72-Hour Warm-Hold Baby Formula Water Warmer & Dechlorinating Glass Kettle (1.3L) – Electric Kettle & Water Boiler",
    "price": 56.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100194AURGEN199",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-199",
    "asin": "B0HNWSKCZL",
    "name": "Double-Wall Cool-Touch Digital Electric Kettle 1.5L with Real-Time LED Screen (Matte White)",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100195AURGEN200B",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-200B",
    "asin": "B0HP5V29R3",
    "name": "1.0L Borosilicate Glass & Stainless Gooseneck Electric Kettle – Fast Boil Cordless Water Boiler with Brew Stopwatch",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100196AURGEN201",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-201",
    "asin": "B0HNWX853V",
    "name": "Ceramic Electric Tea Kettle 1.2L Cordless Porcelain Teapot with Boil-Dry Safety Shutoff",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100197AURGEN202A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-202A",
    "asin": "B0HP5MK9R8",
    "name": "1500W Brushed Stainless Steel Electric Kettle 1.7L with Water Window & Scale Filter",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100198AURGEN203",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-203",
    "asin": "B0HNWZZFXM",
    "name": "WiFi Smart Voice-Controlled Electric Kettle 1.7L with Schedule Brew & Keep-Warm App",
    "price": 62.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100199AURGEN204A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-204A",
    "asin": "B0HP5KVRL7",
    "name": "Copper-Accent Glass Electric Kettle 1.8L with Fast 1500W Heating Element & Amber LED",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100200AURGEN205",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-205",
    "asin": "B0HNWZLVLR",
    "name": "3-Second Instant Hot Water Dispenser Countertop Tank 3.0L with 5 Temperature & Volume Keys",
    "price": 74.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100201AURGEN206A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-206A",
    "asin": "B0HP5GVBJ1",
    "name": "12V/24V Car & Truck Electric Kettle 500ml Road-Trip Heated Travel Coffee Boiler Mug",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100202AURGEN207",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-207",
    "asin": "B0HP5TYMK3",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 207)",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100203AURGEN208",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-208",
    "asin": "B0HP5VBTB6",
    "name": "No-drill Wall-mounted Storage Rack For Bathrooms And Toilets",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100204AURGEN209",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-209",
    "asin": "B0HP5XH8W4",
    "name": "Washing Machine Drain Pan Cleaning Tool – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100205AURGEN210",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-210",
    "asin": "B0HP61WPJS",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 210)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100206AURGEN211",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-211",
    "asin": "B0HP61557D",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 211)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100207AURGEN212",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-212",
    "asin": "B0HP5ZZGL5",
    "name": "Punch-free Rotating Bathroom Storage Rack Wall-mounted Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100208AURGEN213",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-213",
    "asin": "B0HP65FLWJ",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 213)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100209AURGEN214",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-214",
    "asin": "B0HP5X95VN",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 214)",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100210AURGEN215",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-215",
    "asin": "B0HP5Z4GDM",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 215)",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100211AURGEN216",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-216",
    "asin": "B0HP5XBGXZ",
    "name": "Christmas Small Envelope Storage Bag Festive Holiday Gift Wrapper – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100212AURGEN217",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-217",
    "asin": "B0HP5WT8GW",
    "name": "High-end All-around Toilet Brush For Home Use – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100213AURGEN218",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-218",
    "asin": "B0HP63BWJ6",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 218)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100214AURGEN219",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-219",
    "asin": "B0HP5RZ2RK",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 219)",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100215AURGEN220",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-220",
    "asin": "B0HP5ZYKCJ",
    "name": "Bedding Storage Organizer Box For Home Use, For Sheets",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100216AURGEN221",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-221",
    "asin": "B0HP5S32W7",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 221)",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100217AURGEN222",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-222",
    "asin": "B0HP636S25",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 222)",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100218AURGEN223",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-223",
    "asin": "B0HP5S1GPK",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 223)",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100219AURGEN224",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-224",
    "asin": "B0HP61X83J",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 224)",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100220AURGEN225",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-225",
    "asin": "B0HP5TZ42F",
    "name": "Car Beauty Cleaning Brush Set – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100221AURGEN226",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-226",
    "asin": "B0HP5X6Y4R",
    "name": "Fixed Travel Sleep Neck Pillow And Blackout Eye Mask – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100222AURGEN227",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-227",
    "asin": "B0HP5XJGD8",
    "name": "Electric Dinosaur Toy For Boys – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100223AURGEN228",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-228",
    "asin": "B0HP5V248R",
    "name": "Solid Color Large Capacity Fluffy Liner Makeup Storage Bag – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100224AURGEN229",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-229",
    "asin": "B0HP5TY1DG",
    "name": "In 15000pa Powerful Car Vacuum Cleaner Cordless Strong Handheld – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 80.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100225AURGEN230",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-230",
    "asin": "B0HP5RSSGB",
    "name": "Women Fallwinter Slim-fit Round-neck Quick-drying Sports Top – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100226AURGEN231",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-231",
    "asin": "B0HP5V248S",
    "name": "Children Electric Bunny Tricycle Plastic – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100227AURGEN232",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-232",
    "asin": "B0HP63PPN1",
    "name": "Silent Wind Cave Stone Storage Tray Bedroom Decoration Ornaments – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100228AURGEN233",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-233",
    "asin": "B0HP68K25S",
    "name": "40pcs Car Detailing Brush Set Soft Brush Interior Wheel",
    "price": 77.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100229AURGEN234",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-234",
    "asin": "B0HP5VD5LY",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 234)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100230AURGEN235",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-235",
    "asin": "B0HP682FPS",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 235)",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100231AURGEN236",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-236",
    "asin": "B0HP5PDS4J",
    "name": "Large Capacity Shopping Bags Multifunctional Storage Bag – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100232AURGEN237",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-237",
    "asin": "B0HP65PWFV",
    "name": "This Brush With Stand And Dispenser Of Soap Is – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100233AURGEN238",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-238",
    "asin": "B0HP5X6HGY",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 238)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100234AURGEN239",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-239",
    "asin": "B0HP5X7YZB",
    "name": "Electric Fuel Pump Module Fit For Chevy City Express – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100235AURGEN240",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-240",
    "asin": "B0HP5RMC72",
    "name": "Tracking Id Card Storage Anti-loss Alarm Device – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100236AURGEN241",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-241",
    "asin": "B0HP5Z92KK",
    "name": "Whipper Snipper Mower Cordless Grass Trimmer Lawn Brush Cutter",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100237AURGEN242",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-242",
    "asin": "B0HP5PHH5L",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 242)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100238AURGEN243",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-243",
    "asin": "B0HP5PKW3N",
    "name": "Electric Fuel Pump Module Fit For Chrysler 300 Dodge – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100239AURGEN244",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-244",
    "asin": "B0HP659DV5",
    "name": "Quilted Hair Dryer Storage Bag – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100240AURGEN245",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-245",
    "asin": "B0HP5Z2KM5",
    "name": "This Estropajero Double With Finish Of Marble White Of – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100241AURGEN246",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-246",
    "asin": "B0HP5TQ1DS",
    "name": "Women Leopard Print High Neck Chunky Knit Sweater Loose – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100242AURGEN247",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-247",
    "asin": "B0HP5VBTDT",
    "name": "1.5L Stainless Steel Cordless Electric Water Kettle with Retractable Power Cord Base",
    "price": 65.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100243AURGEN248",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-248",
    "asin": "B0HP5WX28L",
    "name": "Cosmetic Storage Bag Large Capacity Cosmetic Case – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100244AURGEN249",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-249",
    "asin": "B0HP5X8S3D",
    "name": "This Irrigador Bucal Of Argon Is Solution Complete For – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100245AURGEN250",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-250",
    "asin": "B0HP661C4K",
    "name": "Womens High-end, Intricately Crafted Lace-embellished Halter-neck Dress – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100246AURGEN251",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-251",
    "asin": "B0HP5SS886",
    "name": "Electric Radiator Cooling Fan Fit For Honda Cr-v 4l – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100247AURGEN252",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-252",
    "asin": "Pending ASIN",
    "name": "3-Tier Floating Wall Mounted Storage Shelf & Bathroom Organizer Rack (Matte White)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100248AURGEN253",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-253",
    "asin": "B0HP5PQ63N",
    "name": "Dispenser Of Kitchen With Estropajo And Brush In White,",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100249AURGEN254",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-254",
    "asin": "B0HP5RSJZT",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 254)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100250AURGEN255",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-255",
    "asin": "B0HP5ZP5LD",
    "name": "12v Iesel Transfer Pump 45l Min Electric Car Oil – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100251AURGEN256",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-256",
    "asin": "B0HP5ZLJY6",
    "name": "Sunshade Portable Laptop Storage Bag – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100252AURGEN257",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-257",
    "asin": "B0HP646NSK",
    "name": "This Aspirador Of Hand From The Brand Argon Is – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100253AURGEN258",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-258",
    "asin": "B0HP63L2M6",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 258)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100254AURGEN259",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-259",
    "asin": "B0HP6419F5",
    "name": "Climbing Santa Claus On Ladder, Electric Musical Christmas Decoration – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100255AURGEN260",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-260",
    "asin": "B0HP5S38M3",
    "name": "Kids Study Desk And Chair Set With Storage, Pink – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100256AURGEN261",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-261",
    "asin": "B0HP5VDTFZ",
    "name": "Low-moisture Cleaning Foam For Automobile Ceiling – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100257AURGEN262",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-262",
    "asin": "B0HP5RCTYZ",
    "name": "Women Solid-color Loose-fitting Patchwork Crew-neck Sweatshirt – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100258AURGEN263",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-263",
    "asin": "B0HP65T39B",
    "name": "Md0505e Electric Motor 1/2hp, 1750rpm General Purpose Motor, Dc – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100259AURGEN264",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-264",
    "asin": "B0HP61XYF5",
    "name": "Universal Bike Repair Stand Adjustable Bicycle Maintenance Station Rack",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100260AURGEN265",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-265",
    "asin": "B0HP5X2CD1",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 265)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100261AURGEN266",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-266",
    "asin": "B0HP63BTJP",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 266)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100262AURGEN267",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-267",
    "asin": "B0HP658ZVS",
    "name": "Hornillo Electric Double Of Black With Power Of 2000w, – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 70.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100263AURGEN268",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-268",
    "asin": "B0HP619V75",
    "name": "Power Steering Rack Pinion Assembly Fit For Hummer H3",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100264AURGEN269",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-269",
    "asin": "B0HP5RG7LD",
    "name": "Wash-free Cleaning Foam For Braiding Dirty Hair – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100265AURGEN270",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-270",
    "asin": "B0HP5WQ32D",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 270)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100266AURGEN271",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-271",
    "asin": "B0HP5ZHG7V",
    "name": "This Pelador Electric Of Argon Is The Tool Ideal – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100267AURGEN272",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-272",
    "asin": "B0HP5PGWDT",
    "name": "This Manguera Of 10 Meters Has With Modos Of – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100268AURGEN273",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-273",
    "asin": "B0HP5RXCTN",
    "name": "Body Brush – Long-Reach Bristle Scrubber & Household Cleaning Brush",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100269AURGEN274",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-274",
    "asin": "B0HP63J61D",
    "name": "Black Lace Sheer Bodysuit With Halter Neck And Strappy – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100270AURGEN275",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-275",
    "asin": "B0HP5V9MM1",
    "name": "This Hornillo Electric Double Of Argon Is Solution Efficient – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100271AURGEN276",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-276",
    "asin": "B0HP5TXL4M",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 276)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100272AURGEN277",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-277",
    "asin": "B0HP5V87RS",
    "name": "Facial Massage Crescent-shaped Lymph Contour Brush",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100273AURGEN278",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-278",
    "asin": "B0HP5RBG5F",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 278)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100274AURGEN279",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-279",
    "asin": "B0HP5PP35F",
    "name": "Molinillo Electric Of Steel Designed For Its Use In – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100275AURGEN280",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-280",
    "asin": "B0HP68GMXH",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 280)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100276AURGEN281",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-281",
    "asin": "B0HP5Z5YDB",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 281)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100277AURGEN282",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-282",
    "asin": "B0HP611VFH",
    "name": "Round Neck Dress With Pockets – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100278AURGEN283",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-283",
    "asin": "B0HP5S38M8",
    "name": "Egr Valve Kit Fit For Honda Accord Odyssey V6 – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100279AURGEN284",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-284",
    "asin": "B0HP5RFSGQ",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 284)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100280AURGEN285",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-285",
    "asin": "B0HP61SNG8",
    "name": "Engine Degreaser Cleaner, Glass Degreaser, Windshield Decontamination Waterproof Rain – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100281AURGEN286",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-286",
    "asin": "B0HP68G8D2",
    "name": "Half-high Neck Thickened Soft And Cozy Loose-fit Pullover Knit – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100282AURGEN287",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-287",
    "asin": "B0HP5X52FY",
    "name": "Electric Fuel Pump Module Assembly Fit For Silverado 1500 – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100283AURGEN288",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-288",
    "asin": "B0HP5YWCTQ",
    "name": "Silverware Caddy Cutlery Holder Storage Spoon Fork Utensil Caddy – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100284AURGEN289",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-289",
    "asin": "B0HP5PHPM9",
    "name": "Windshield Cleaning Kit, Glass Decontamination Waterproof Rainproof Set – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100285AURGEN290",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-290",
    "asin": "B0HP5RBRWX",
    "name": "Black Mesh Sheer Bodysuit With Halter Neck Tie Straps – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100286AURGEN291",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-291",
    "asin": "B0HP5RBJNM",
    "name": "Electric Fuel Pump Assembly Fit For Toyota Sequoia Tundra – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100287AURGEN292",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-292",
    "asin": "Pending ASIN",
    "name": "This Container Leknes Is Ideal For Storage And Organization – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100288AURGEN293",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-293",
    "asin": "B0HP63TH79",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 293)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100289AURGEN294",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-294",
    "asin": "B0HP5V9VKZ",
    "name": "Long Dress Set Vintage Round-neck Evening Gown For Banquets – Rechargeable Meridian & Muscle Relief Massager",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100290AURGEN295",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-295",
    "asin": "Pending ASIN",
    "name": "1.7L Fast-Boil Cordless Stainless Electric Kettle & Countertop Hot Water Boiler",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100291AURGEN296",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-296",
    "asin": "B0HP5RJMC9",
    "name": "This Basket Rectangular With Handles In Natural Is Practical – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100292AURGEN297",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-297",
    "asin": "B0HP615Y2P",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 297)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100293AURGEN298",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-298",
    "asin": "B0HP5RL9YT",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 298)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100294AURGEN299",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-299",
    "asin": "B0HP5PMP1R",
    "name": "Hornillo Electric Of Stainless Steel With Power Of 1500w, – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100295AURGEN300",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-300",
    "asin": "B0HP5ZTMH9",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 300)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100296AURGEN301",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-301",
    "asin": "B0HP618285",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 301)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100297AURGEN302",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-302",
    "asin": "B0HP5ZJVBC",
    "name": "Ruffled Mock-neck Layered Tiered Long Dress – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100298AURGEN303",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-303",
    "asin": "Pending ASIN",
    "name": "Electric Foot Massager Shiatsu Kneading Foot Massage Machine For – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100299AURGEN304",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-304",
    "asin": "B0HP61WNCL",
    "name": "Jar Of Glass With Lid Of Steel, Ideal For – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100300AURGEN305",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-305",
    "asin": "B0HP5XQLR9",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 305)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100301AURGEN306",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-306",
    "asin": "B0HP68K399",
    "name": "Loose Short-sleeved Round Neck Long Skirt – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100302AURGEN307",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-307",
    "asin": "B0HP5RR2F7",
    "name": "2200w Single Electric Induction Hob Hot Plate Cooker Portable – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100303AURGEN308",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-308",
    "asin": "B0HP65BZFW",
    "name": "This Box Of Tinplate With Design Of Embossed For – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100304AURGEN309",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-309",
    "asin": "B0HP5X2YC3",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 309)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100305AURGEN310",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-310",
    "asin": "B0HP5V3N7M",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 310)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100306AURGEN311",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-311",
    "asin": "B0HP5YWCTS",
    "name": "Electric Santa Climbing Race Toy Set With Led Lights, – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100307AURGEN312",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-312",
    "asin": "B0HP5WZGS2",
    "name": "Optimize Its Space Of Storage With This Pack Of – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100308AURGEN313",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-313",
    "asin": "B0HP612NP6",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 313)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100309AURGEN314",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-314",
    "asin": "B0HP5ZG5BD",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 314)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100310AURGEN315",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-315",
    "asin": "B0HP5TQJ9H",
    "name": "This Hornillo Electric From The Brand Argon Is Solution – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100311AURGEN316",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-316",
    "asin": "B0HP5X5C6L",
    "name": "This Mueble Of Drawers With Effect Wood Offers Solution – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100312AURGEN317",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-317",
    "asin": "B0HP5RV3N2",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 317)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100313AURGEN318",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-318",
    "asin": "B0HP5PQVV6",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 318)",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100314AURGEN319",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-319",
    "asin": "B0HP5RMGMS",
    "name": "This Paella Pan Electric Of Argon Is The Tool – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100315AURGEN320",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-320",
    "asin": "B0HP5X4N7Q",
    "name": "This Elegant Frasco Of Glass With Design Of Diamond – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100316AURGEN321",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-321",
    "asin": "B0HP5ZB584",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 321)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100317AURGEN322",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-322",
    "asin": "B0HP5WRYZR",
    "name": "Women Round-neck Sleeveless Waist-cinching Vest – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100318AURGEN323",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-323",
    "asin": "Pending ASIN",
    "name": "The Lima Electric For Foots Of Argon Offers Solution – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100319AURGEN324",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-324",
    "asin": "B0HP5TWQHM",
    "name": "Cube Storage Organizer, White Texture – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100320AURGEN325",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-325",
    "asin": "B0HP5RNCKS",
    "name": "Car Cleaning Care Kit, Decontamination Scratch Restoration Wash – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100321AURGEN326",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-326",
    "asin": "B0HP644P6Q",
    "name": "Simple And Versatile Womens Crew-neck Knit Sweater – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100322AURGEN327",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-327",
    "asin": "B0HP5ZCG4C",
    "name": "Motorcycle And Electric Scooter Helmet – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100323AURGEN328",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-328",
    "asin": "B0HP5WX291",
    "name": "Container Metal Square Biscuit In White With Lid Of – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100324AURGEN329",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-329",
    "asin": "B0HP5XQ3S1",
    "name": "Men Beard Wash Shampoo Cleansing Moisturizing Softening Beard Care – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100325AURGEN330",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-330",
    "asin": "B0HP5ZP6VJ",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 330)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100326AURGEN331",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-331",
    "asin": "B0HP646NSN",
    "name": "Portable Household Plug-in Electric Blanket For One Or Two – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100327AURGEN332",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-332",
    "asin": "B0HP5RPVFK",
    "name": "Foldable Storage Box 30l, Assorted Gray Beige Dark Brown, – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100328AURGEN333",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-333",
    "asin": "B0HP5RJ1Z2",
    "name": "Hair Brush 1g Long Lasting Hold Grey Hair Covering",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100329AURGEN334",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-334",
    "asin": "B0HP638342",
    "name": "Men Round-neck Sports T-shirt Top – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100330AURGEN335",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-335",
    "asin": "B0HP5TVBD9",
    "name": "Rechargeable Lithium Battery Professional Type Electric Grinding Set Advanced – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100331AURGEN336",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-336",
    "asin": "Pending ASIN",
    "name": "This Box Pl Stica Of The Line Vibes Of – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100332AURGEN337",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-337",
    "asin": "B0HP5TR1JY",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 337)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100333AURGEN338",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-338",
    "asin": "B0HP63MHVB",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 338)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100334AURGEN339",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-339",
    "asin": "B0HP63BS8Z",
    "name": "Large Christmas Tree Electric Rotating Base Stand – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 53.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100335AURGEN340",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-340",
    "asin": "B0HP5TQ97W",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 340)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100336AURGEN341",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-341",
    "asin": "B0HP66GSLV",
    "name": "Men Boar Bristle Beard Brush Portable Wooden Handle Grooming",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100337AURGEN342",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-342",
    "asin": "B0HP61TXD1",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 342)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100338AURGEN343",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-343",
    "asin": "B0HP5RVKYF",
    "name": "Universal 12v 24v Electric Fuel Pump Hep02a Inline Gasoline – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100339AURGEN344",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-344",
    "asin": "B0HP5ZGVC4",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 344)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100340AURGEN345",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-345",
    "asin": "B0HP5Z7VCC",
    "name": "Rechargeable Electric Rotary Grill Brush-free Bbq Grill Cleaner Bbq",
    "price": 68.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100341AURGEN346",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-346",
    "asin": "B0HP5PNQ7D",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 346)",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100342AURGEN347",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-347",
    "asin": "B0HP5ZB7W1",
    "name": "Kma104 41 Inch Dreadnought Cutaway Acoustic Electric Guitar, Basswood – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100343AURGEN348",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-348",
    "asin": "B0HP65PDDY",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 348)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100344AURGEN349",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-349",
    "asin": "B0HP5RBJNX",
    "name": "Ceramic Glass Cleaning Kit, Windshield Stain And Oil Film – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100345AURGEN350",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-350",
    "asin": "B0HP5ZW4H5",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 350)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100346AURGEN351",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-351",
    "asin": "B0HP5X5C6R",
    "name": "Diy String Flame Shaped Style Hsh Electric Guitar Kits – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100347AURGEN352",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-352",
    "asin": "B0HP5XC822",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 352)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100348AURGEN353",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-353",
    "asin": "B0HP5Z4GF9",
    "name": "Car Cleaning Kit, Includes Wash Mitt, Car Wiping Cloths, – Long-Reach Bristle Scrubber & Household Cleaning Brush",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100349AURGEN354",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-354",
    "asin": "B0HP5TTX76",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 354)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100350AURGEN355",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-355",
    "asin": "B0HP65NPJ5",
    "name": "2000w Electric Pressure Washer High Power Car Cleaner Jet – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100351AURGEN356",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-356",
    "asin": "B0HP5YVKTH",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 356)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100352AURGEN357",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-357",
    "asin": "B0HP5WWGS3",
    "name": "Windshield Effervescent Tablets, Window Stain Waterproof Cleaning Tabs – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100353AURGEN358",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-358",
    "asin": "B0HP61JBGH",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 358)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100354AURGEN359",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-359",
    "asin": "B0HP5V2F35",
    "name": "Stand Mixer Food Mixer Electric Whisk 10 Speed With – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100355AURGEN360",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-360",
    "asin": "B0HP5XSDKK",
    "name": "This Bucket Foldable From The Brand Alsek Is Practical – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100356AURGEN361",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-361",
    "asin": "B0HP658WSR",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 361)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100357AURGEN362",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-362",
    "asin": "Pending ASIN",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 362)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100358AURGEN363",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-363",
    "asin": "B0HP5TV6ZL",
    "name": "4600w 220v Electric Welder Hand Held Welding Machine Kit – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100359AURGEN364",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-364",
    "asin": "B0HP5PMHB2",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 364)",
    "price": 75.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100360AURGEN365",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-365",
    "asin": "B0HP5PHCWY",
    "name": "Car Ceramic Coating Agent, Nano Coating Brush, Decontamination Rain",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100361AURGEN366",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-366",
    "asin": "B0HP5ZXXCL",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 366)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100362AURGEN367",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-367",
    "asin": "B0HP5XP8DP",
    "name": "Cordless Electric Grease Gun Cartridges 600cc 6000psi For Akita – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100363AURGEN368",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-368",
    "asin": "B0HP63PBWC",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 368)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100364AURGEN369",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-369",
    "asin": "B0HP5X95W3",
    "name": "Car Cleaning Gel, Interior Crevice Vent Detailing Putty – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100365AURGEN370",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-370",
    "asin": "B0HP5VK9RT",
    "name": "Jyf New Foreign Trade Cross-border Women Clothing Casual – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100366AURGEN371",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-371",
    "asin": "B0HP5X3VJG",
    "name": "Electric High Power Pressure Washer Adjustment Patio Rv Versatile – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100367AURGEN372",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-372",
    "asin": "B0HP5XR6M6",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 372)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100368AURGEN373",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-373",
    "asin": "B0HP63BPX4",
    "name": "Car Scratch Care Kit, Paint Stain Gloss Cleaning Restoration – Long-Reach Bristle Scrubber & Household Cleaning Brush",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100369AURGEN374",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-374",
    "asin": "B0HP65V7HB",
    "name": "Women Two Piece Set Neck Long Sleeve Wrap Top – Rechargeable Meridian & Muscle Relief Massager",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100370AURGEN375",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-375",
    "asin": "B0HP5X2KD4",
    "name": "Gib Electric String Bass Guitar Full Size Bag Strap – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100371AURGEN376",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-376",
    "asin": "B0HP5RMRK2",
    "name": "Universal Aluminium Car Roof Rack Luggage Carrier Cross Bars",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100372AURGEN377",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-377",
    "asin": "B0HP5YX9RS",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 377)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100373AURGEN378",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-378",
    "asin": "B0HP5X1ZHN",
    "name": "Sexy Lace Backless Round Neck Fitted Long Sleeve T-shirt – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100374AURGEN379",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-379",
    "asin": "B0HP5RPPQH",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 379)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100375AURGEN380",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-380",
    "asin": "B0HP5TPXWY",
    "name": "This Assortment Of Containers Plastics Highs Is Ideal For – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100376AURGEN381",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-381",
    "asin": "B0HP5TVFN2",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 381)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100377AURGEN382",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-382",
    "asin": "B0HP5ZZDCS",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 382)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100378AURGEN383",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-383",
    "asin": "B0HP5XHVGM",
    "name": "21v Electric Cordless Electric Soil Cultivator 550w High Power – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100379AURGEN384",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-384",
    "asin": "B0HP6578W7",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 384)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100380AURGEN385",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-385",
    "asin": "B0HP6197T1",
    "name": "Car Oil Film Cleaning Brush, Windshield Glass Oil Stain",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100381AURGEN386",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-386",
    "asin": "B0HP5TYFNQ",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 386)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100382AURGEN387",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-387",
    "asin": "B0HP5PPKWY",
    "name": "Front Left Lh Electric Window Regulator W/ Motor Fit – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100383AURGEN388",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-388",
    "asin": "B0HP5WVNFV",
    "name": "Jar Round Made Of Glass Of Borosilicate With Lid – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100384AURGEN389",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-389",
    "asin": "B0HP5X2KDF",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 389)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100385AURGEN390",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-390",
    "asin": "B0HP5WXDGV",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 390)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100386AURGEN391",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-391",
    "asin": "B0HP5VKFD1",
    "name": "Auto Shut-Off 1500W Stainless Steel Cordless Electric Water Boiler (Series 391)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100387AURGEN392",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-392",
    "asin": "B0HP5PJS1Z",
    "name": "Frasco Of Glass Square In Amber, Ideal For Various – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100388AURGEN393",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-393",
    "asin": "B0HP5XGRQL",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 393)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100389AURGEN394",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-394",
    "asin": "B0HP5RNGLG",
    "name": "Loose Long Sleeve Inner Wear – Rechargeable Meridian & Muscle Relief Massager",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100390AURGEN395",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-395",
    "asin": "B0HP63XW57",
    "name": "7l Automatic Electric Dough Mixer Kneading Dough Maker Ferment – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100391AURGEN396",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-396",
    "asin": "B0HP5RK14K",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 396)",
    "price": 88.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100392AURGEN397",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-397",
    "asin": "B0HP5RPC5Z",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 397)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100393AURGEN398",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-398",
    "asin": "B0HP5XCYNZ",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 398)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100394AURGEN399",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-399",
    "asin": "B0HP5XGRQK",
    "name": "Electric Dough Mixer Kneading Ferment Automatic Domestic Function Kitchen – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100395AURGEN400",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-400",
    "asin": "B0HP63BPXB",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 400)",
    "price": 84.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100396AURGEN401",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-401",
    "asin": "B0HP65T3B1",
    "name": "Beard Filler Pencil Men Beard Filler Pen Waterproof Pencil – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100397AURGEN402",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-402",
    "asin": "B0HP5RLYWC",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 402)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100398AURGEN403",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-403",
    "asin": "B0HP5RKNG8",
    "name": "Under Desk Elliptical Machine Compact Electric Leg Foot Pedal – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100399AURGEN404",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-404",
    "asin": "B0HP613KGV",
    "name": "This Basket Rectangular Is Practical And Elegant Solution For – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100400AURGEN405",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-405",
    "asin": "B0HP65JDGQ",
    "name": "Beard Wash Men Beard Nourishing Cleanser Deep Cleaning Moisturizing – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100401AURGEN406",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-406",
    "asin": "B0HP65MWL5",
    "name": "Men Plaid Fleece Lined Knit Cardigan, Crew Neck Button – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100402AURGEN407",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-407",
    "asin": "B0HP61SGS9",
    "name": "3l Instant Hot Water Dispenser Digital Kettle Temp Control",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100403AURGEN408",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-408",
    "asin": "B0HP5X9673",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 408)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100404AURGEN409",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-409",
    "asin": "B0HP5RZ69X",
    "name": "Crystal Glass Cleaner Kit, Rainproof Decontamination Windshield Brush Set",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100405AURGEN410",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-410",
    "asin": "B0HP686RQR",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 410)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100406AURGEN411",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-411",
    "asin": "B0HP5RT88X",
    "name": "Women Black Ruffle Sleeve Blouse High Neck Tiered Bell – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100407AURGEN412",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-412",
    "asin": "Pending ASIN",
    "name": "In1 Electric Meat Grinder Meat Mincer Sausage Stuffer Vegetable – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100408AURGEN413",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-413",
    "asin": "B0HP5PH9KX",
    "name": "Men Facial Cleanser Gentle Moisturizing Face Wash Deep Cleaning – Non-Scratch Pot, Pan & Sink Scrubbing Cleaning Brush",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100409AURGEN414",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-414",
    "asin": "B0HP5RRRSC",
    "name": "Set Of Containers For Storage Of Food From The – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100410AURGEN415",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-415",
    "asin": "B0HP5TTQW6",
    "name": "Women Ruffle Neck Embroidery Blouse Long Sleeve Eyelet Lace – Full-Body Deep Kneading Roller & Muscle Recovery Massager",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100411AURGEN416",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-416",
    "asin": "B0HP646CYM",
    "name": "Basket With Handles Of Shape Oval, Ideal For Organization – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100412AURGEN417",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-417",
    "asin": "B0HP5XLNL2",
    "name": "Bamboo Kitchen Storage Drawer For Cutlery – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100413AURGEN418",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-418",
    "asin": "B0HP5V7QSV",
    "name": "Rapid-Boil Double-Wall Insulated Countertop Electric Hot Water Kettle (Series 418)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100414AURGEN419",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-419",
    "asin": "B0HP5XV1QF",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 419)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100415AURGEN420",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-420",
    "asin": "B0HP5RZ69S",
    "name": "Men Facial Cleanser Gentle Foaming Face Wash Deep Cleaning – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100416AURGEN421",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-421",
    "asin": "B0HP5RDKBB",
    "name": "2x Electric Brake Calipers Replacement For Audi A8 S8 – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100417AURGEN422",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-422",
    "asin": "B0HP5X8ZGL",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 422)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100418AURGEN423",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-423",
    "asin": "B0HP5XJVST",
    "name": "6l Digital Electric Pressure Cooker 12-in-1 Non Stick Cooker – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100419AURGEN424",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-424",
    "asin": "B0HP5ZC8CL",
    "name": "Container Of Tinplate Rectangular With Design Organic Chocolate From – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100420AURGEN425",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-425",
    "asin": "Pending ASIN",
    "name": "Car Cleaning Liquid, Surface Decontamination Restoration Daily Care – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100421AURGEN426",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-426",
    "asin": "B0HP5XQ6XF",
    "name": "Electric Pressure Washer 1450psi 00bar 1200w High Power Jet – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100422AURGEN427",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-427",
    "asin": "B0HP66K3N1",
    "name": "Hardware Storage Bag Shoulder Portable Toolkit – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100423AURGEN428",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-428",
    "asin": "B0HP5VGXJL",
    "name": "Double-layer Large Capacity Travel Jewelry Storage Bag – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100424AURGEN429",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-429",
    "asin": "B0HP5ZFGKT",
    "name": "Cordless Hammer Drill Sds Rotary Electric Impact Hammer Heavy – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100425AURGEN430",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-430",
    "asin": "B0HP5XND5L",
    "name": "3in1 Polar Fleece Balaclava Hood, Multifunctional Windproof Thermal Full – Cervical Neck, Shoulder & Back Shiatsu Kneading Massager",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100426AURGEN431",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-431",
    "asin": "B0HP5Z92WQ",
    "name": "Window Cleaning Machine Intelligent Window Cleaning Robot Automatic Electric – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100427AURGEN432",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-432",
    "asin": "B0HP5ZKVD1",
    "name": "Breathable Shoe Compartment Cricket Bat Storage Bag – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100428AURGEN433",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-433",
    "asin": "B0HP5X2RXM",
    "name": "Beard Wash Men Beard Grooming Kit Complete Beard Care – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100429AURGEN434",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-434",
    "asin": "B0HP5XV4JR",
    "name": "Makeup And Skincare Storage Single-shoulder Backpack – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 33.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100430AURGEN435",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-435",
    "asin": "B0HP5Z58R2",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 435)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100431AURGEN436",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-436",
    "asin": "B0HP5PK9M7",
    "name": "2500w 8l Portable Handheld Steam Cleaner High Temp Steam – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100432AURGEN437",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-437",
    "asin": "B0HP5RMKKW",
    "name": "Fishing Tackle Backpack Belt Large Outdoor Storage – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100433AURGEN438",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-438",
    "asin": "B0HP5ZSRWK",
    "name": "Cordless Electric Grass Trimmer Multi-functional Brushless Engine Lawn Edger – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100434AURGEN439",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-439",
    "asin": "B0HP5TSFRG",
    "name": "Electric Dough Mixer Auto Kneading Dough Maker Domestic Kitchen – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100435AURGEN440",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-440",
    "asin": "B0HP5WV8ZP",
    "name": "Cleaning Sponge, Glass Hydrophobic Snow Ice Removal Sponge – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100436AURGEN441",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-441",
    "asin": "B0HP5XSWPC",
    "name": "3-tier Side Table With Storage, Nightstand End Table With – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 77.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100437AURGEN442",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-442",
    "asin": "Pending ASIN",
    "name": "Set Of Storage Of Leknes Includes Lunch Box And – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100438AURGEN443",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-443",
    "asin": "B0HP5XTSBD",
    "name": "Fan Heater Portable Electric Hot Warm With Heat Settings – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 68.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100439AURGEN444",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-444",
    "asin": "B0HP5RY62X",
    "name": "Sink Storage Cabinet, Under Sink Cabinet With Double Doors, – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100440AURGEN445",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-445",
    "asin": "B0HP5TPBX5",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 445)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100441AURGEN446",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-446",
    "asin": "B0HP5ZFGKV",
    "name": "Rapid-Boil Double-Wall Insulated Countertop Electric Hot Water Kettle (Series 446)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100442AURGEN447",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-447",
    "asin": "B0HP5V14FD",
    "name": "Wiper Oil Film Cleaning Tablets, Windshield Rainproof Glass Tabs – Stiff-Bristle Crevice, Window Track & Tile Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100443AURGEN448",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-448",
    "asin": "B0HP5ZFGKQ",
    "name": "2-tier Rattan Wicker Side Table Outdoor Patio Table With – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100444AURGEN449",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-449",
    "asin": "B0HP65JFPB",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 449)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100445AURGEN450",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-450",
    "asin": "B0HP5RS5N5",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 450)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100446AURGEN451",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-451",
    "asin": "B0HP5S2WT3",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 451)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100447AURGEN452",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-452",
    "asin": "B0HP5XTTWX",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 452)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100448AURGEN453",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-453",
    "asin": "B0HP5VBJT6",
    "name": "Replace 47163782 St High Grade Electric Guitar Square Hard – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100449AURGEN454",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-454",
    "asin": "B0HP5XVMH7",
    "name": "Rapid-Boil Double-Wall Insulated Countertop Electric Hot Water Kettle (Series 454)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100450AURGEN455",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-455",
    "asin": "B0HP5V3BKT",
    "name": "Folding Director Chair With Side Table Storage Pockets, 41 – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100451AURGEN456",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-456",
    "asin": "B0HP5WR96G",
    "name": "Botanical Hair Brush 150ml Damaged Hair Repair Smoothing And",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100452AURGEN457",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-457",
    "asin": "B0HP5TPYZC",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 457)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100453AURGEN458",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-458",
    "asin": "B0HP63THMQ",
    "name": "Wood 2-tier Freestanding Water Fountain Barrel Waterfall With Electric",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100454AURGEN459",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-459",
    "asin": "B0HP5ZJYD1",
    "name": "Hair Brush 6-piece Smoothing And Detangling Nourishing Moisturizing Long",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100455AURGEN460",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-460",
    "asin": "B0HP5XBH9Q",
    "name": "Outdoor Storage Box – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100456AURGEN461",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-461",
    "asin": "B0HP5PFZJ4",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 461)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100457AURGEN462",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-462",
    "asin": "B0HP63JP5K",
    "name": "Electric Pressure Washer 1450psi 1200w 00bar High Power Jet – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100458AURGEN463",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-463",
    "asin": "B0HP61J685",
    "name": "Outdoor Storage Box – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100459AURGEN464",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-464",
    "asin": "B0HP618LNY",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 464)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100460AURGEN465",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-465",
    "asin": "B0HP5PS6B3",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 465)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100461AURGEN466",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-466",
    "asin": "B0HP65KDSG",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 466)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100462AURGEN467",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-467",
    "asin": "B0HP6789WY",
    "name": "Omen Round Neck Long Sleeve Polka Dot Blouse Elegant – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100463AURGEN468",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-468",
    "asin": "B0HP63LZFW",
    "name": "2800w Electric Meat Grinder Mincer Sausage Maker Filler Home – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100464AURGEN469",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-469",
    "asin": "B0HP5ZYT7C",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 469)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100465AURGEN470",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-470",
    "asin": "B0HP5WRDQ2",
    "name": "69 Tall Bathroom Storage Cabinet With Barn Doors And – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100466AURGEN471",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-471",
    "asin": "B0HP5PLSS9",
    "name": "2800w Electric Meat Grinder Mincer Sausage Maker Filler Kitchen – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100467AURGEN472",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-472",
    "asin": "B0HP63ZHDZ",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 472)",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100468AURGEN473",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-473",
    "asin": "B0HP5RXB28",
    "name": "Women Round Neck Long Sleeve Printed Maxi Dress Elegant – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100469AURGEN474",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-474",
    "asin": "B0HP63RLQH",
    "name": "Metal Racking Shelf Storage180x100x40cm Shelving 70 86in Hx39 37",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100470AURGEN475",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-475",
    "asin": "B0HP61263D",
    "name": "Programmable Robot Children Assembled Remote Control Electric Building Blocks – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100471AURGEN476",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-476",
    "asin": "B0HP5PJJMM",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 476)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100472AURGEN477",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-477",
    "asin": "B0HP5PLH78",
    "name": "Men Beard Filler Pencil Kit 3-in-1 Waterproof Pen Brush",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100473AURGEN478",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-478",
    "asin": "B0HP5TT2SY",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 478)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100474AURGEN479",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-479",
    "asin": "B0HP5X6NXD",
    "name": "Body Wash Salicylic Acid Shower Gel Daily Gentle Cleaning – Stiff-Bristle Crevice, Window Track & Tile Cleaning Brush",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100475AURGEN480",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-480",
    "asin": "B0HP5ZLN3J",
    "name": "Tier Heavy Duty Boltless Metal Shelving Storage Rack Shelf",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100476AURGEN481",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-481",
    "asin": "B0HP65V6N4",
    "name": "Electric Omnidirectional Obstacle-avoidance, Auto-speed-changing Frog Childrens Toy – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100477AURGEN482",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-482",
    "asin": "B0HP5RDY2N",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 482)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100478AURGEN483",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-483",
    "asin": "B0HP5ZC8CR",
    "name": "Electric Kneading Heating Massage Shawl -- Multifunctional Shoulder Neck – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 50.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100479AURGEN484",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-484",
    "asin": "B0HP5RGMVD",
    "name": "61 Shapely Doors Cabinet, Metal Storage Cabinet With Doors – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100480AURGEN485",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-485",
    "asin": "B0HP5RFNYV",
    "name": "Women Two Piece Set Neck Long Sleeve Wrap Top – Handheld Skin Toning & Target Points Body Massager",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100481AURGEN486",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-486",
    "asin": "B0HP619853",
    "name": "Cordless High Pressure Car Washing Gun Rechargeable Portable Power – 360-Degree Rotary Household & Bottle Cleaning Brush",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100482AURGEN487",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-487",
    "asin": "B0HP5VH1DB",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 487)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100483AURGEN488",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-488",
    "asin": "B0HP61SGSF",
    "name": "Plastic Shelving Unit,5 Tier Black,snap Lock Tool-free Assembly,for Garage,warehouse,shed – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100484AURGEN489",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-489",
    "asin": "B0HP65Y4HB",
    "name": "Kids Electric Dishwasher Toy With Water Circulation Simulation Sink",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100485AURGEN490",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-490",
    "asin": "B0HP5X8X5L",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 490)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100486AURGEN491",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-491",
    "asin": "B0HP661KNQ",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 491)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100487AURGEN492",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-492",
    "asin": "B0HP613VSK",
    "name": "Flat Electric Small Handheld Cordless Waxing Machine – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100488AURGEN493",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-493",
    "asin": "B0HP63JW8L",
    "name": "Electric 3d Wooden Puzzles Marble Run Model Kits Brain – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 75.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100489AURGEN494",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-494",
    "asin": "B0HP61WKM3",
    "name": "Halloween Decor Cosmetic Bag Large Capacity Travel Toiletry Bag – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100490AURGEN495",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-495",
    "asin": "B0HP5Z93VX",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 495)",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100491AURGEN496A",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-496A",
    "asin": "Pending ASIN",
    "name": "Ergonomic Shiatsu Cervical Neck & Shoulder Deep Tissue Kneading Massager (496 Series)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100492AURGEN497",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-497",
    "asin": "B0HP65923B",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 497)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100493AURGEN498",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-498",
    "asin": "B0HP5RWHJF",
    "name": "Lightweight Vibrating Neck And Shoulder Massager Belt Portable Trapezius",
    "price": 81.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100494AURGEN499",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-499",
    "asin": "B0HP5SS8KQ",
    "name": "White Rolling Bathroom Storage Cabinet Toilet Paper Organizer With",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100495AURGEN500",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-500",
    "asin": "B0HP5XBZ7G",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 500)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100496AURGEN501",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-501",
    "asin": "B0HP65Y4HF",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 501)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100497AURGEN502",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-502",
    "asin": "B0HP61CGLM",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 502)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100498AURGEN503",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-503",
    "asin": "B0HP63THMT",
    "name": "Short Foot Cordless Electric Screwdriver – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100499AURGEN504",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-504",
    "asin": "B0HP5VB4Q4",
    "name": "Beard Filler Pencil Men Beard Filling Pencil Set Brush",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100500AURGEN505",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-505",
    "asin": "B0HP5V1M9S",
    "name": "Windshield Cleaning Tablets, Window Stain Waterproof Effervescent Tabs – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100501AURGEN506",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-506",
    "asin": "B0HP5XDXFL",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 506)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100502AURGEN507",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-507",
    "asin": "B0HP5S58VR",
    "name": "Uk Granary Blue 12v Brushed Handheld Corner Grinder With – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100503AURGEN508",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-508",
    "asin": "B0HP5X19TM",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 508)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100504AURGEN509",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-509",
    "asin": "Pending ASIN",
    "name": "Electric Dog Toy Creative Cartoon Design Plush Soft Comfort – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100505AURGEN510",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-510",
    "asin": "B0HP5RGV76",
    "name": "Windshield Cleaning Tablets, Window Rainproof Daily Care Effervescent Tabs – 360-Degree Rotary Household & Bottle Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100506AURGEN511",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-511",
    "asin": "B0HP5WTD7T",
    "name": "Tier Heavy Duty Boltless Metal Shelving Storage Rack Shelf (Brushed Graphite Edition · 511 Series)",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100507AURGEN512",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-512",
    "asin": "B0HP5XBRWV",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 512)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100508AURGEN513",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-513",
    "asin": "B0HP655MCN",
    "name": "Precision Gooseneck Pour-Over Electric Tea & Coffee Water Boiler Kettle (Series 513)",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100509AURGEN514",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-514",
    "asin": "B0HP5YZW4N",
    "name": "Kids Bookcase With Collapsible Fabric Drawers, Children Book Display, – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100510AURGEN515",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-515",
    "asin": "B0HP5MGHVR",
    "name": "Beard Brush Men Shaving Soft Bristles Creates Rich Lather",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100511AURGEN516",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-516",
    "asin": "B0HP5RHQYD",
    "name": "Oil Film Cleaning Brush Kit, Windshield Rainproof Glass Cleaning",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100512AURGEN517",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-517",
    "asin": "B0HP5ZMJXM",
    "name": "Car Paint Scratch Care Kit, Cleaning Restoration Gloss Maintenance – Non-Scratch Pot, Pan & Sink Scrubbing Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100513AURGEN518",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-518",
    "asin": "B0HP5PP3FJ",
    "name": "30 Gallon Caddy Tank Storage Drum Diesel Fuel Transfer – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100514AURGEN519",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-519",
    "asin": "B0HP5VJFLS",
    "name": "Shoe Storage Cabinet/shoe Rack – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100515AURGEN520",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-520",
    "asin": "B0HP5TR4VC",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 520)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100516AURGEN521",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-521",
    "asin": "B0HP5PD1DR",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 521)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100517AURGEN522",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-522",
    "asin": "B0HP5WVNSV",
    "name": "Kettle Charcoal Grill With Side Tables, Storage Shelf, Upgraded",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100518AURGEN523",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-523",
    "asin": "B0HP5RJK6F",
    "name": "Black Laundry Hamper Cabinet Tilt-out Baskets, Drawers, Sturdy Home – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100519AURGEN524",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-524",
    "asin": "B0HP5WXCMG",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 524)",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100520AURGEN525",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-525",
    "asin": "B0HP5Z71JR",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 525)",
    "price": 33.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100521AURGEN526",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-526",
    "asin": "B0HP5TPBXF",
    "name": "2l Electric Kettle 1500w Stainless Steel Cordless Jug Overheat",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100522AURGEN527",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-527",
    "asin": "Pending ASIN",
    "name": "Waterproof Dog Car Seat Bed In Convertible Pet Travel – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100523AURGEN528",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-528",
    "asin": "B0HP5WYRRX",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 528)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100524AURGEN529",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-529",
    "asin": "B0HP5S42YT",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 529)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100525AURGEN530",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-530",
    "asin": "B0HP626R8G",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 530)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100526AURGEN531",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-531",
    "asin": "B0HP5RLL32",
    "name": "Soft Dog Travel Crate,grey,collapsible Dog Crate 3-door Durable Mesh – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100527AURGEN532",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-532",
    "asin": "B0HP5VK32K",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 532)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100528AURGEN533",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-533",
    "asin": "B0HP5WWP4N",
    "name": "Maple Fingerboard Gtl Electric Guitar Ss Pickup Transparent Red – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100529AURGEN534",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-534",
    "asin": "B0HP5V8YXS",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 534)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100530AURGEN535",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-535",
    "asin": "B0HP5ZKP8K",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 535)",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100531AURGEN536",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-536",
    "asin": "B0HP5PSX1K",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 536)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100532AURGEN537",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-537",
    "asin": "B0HP5XDX2L",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 537)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100533AURGEN538",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-538",
    "asin": "B0HP5R9RDN",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 538)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100534AURGEN539",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-539",
    "asin": "B0HP5TQ1S4",
    "name": "Kitchen Storage Cabinet Kitchen Cabinet – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100535AURGEN540",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-540",
    "asin": "B0HP65MPTD",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 540)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100536AURGEN541",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-541",
    "asin": "B0HP5S5YQ1",
    "name": "Portable Home Fitness Fascia Ring Massager – Handheld Skin Toning & Target Points Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100537AURGEN542",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-542",
    "asin": "Pending ASIN",
    "name": "Black 12v Kids Ride-on Toy Electric Powered Ride-on Car – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100538AURGEN543",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-543",
    "asin": "B0HP5VJQGQ",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 543)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100539AURGEN544",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-544",
    "asin": "B0HP5XJVT6",
    "name": "Portable Electric Sewing Machine Multifunctional Desktop Household Sewing Machine – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100540AURGEN545",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-545",
    "asin": "B0HP61WPK1",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 545)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100541AURGEN546",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-546",
    "asin": "B0HP5WSS3F",
    "name": "Engine Degreaser Cleaner, Glass Degreaser, Window Oil Stain Dust – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100542AURGEN547",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-547",
    "asin": "B0HP5TS8PH",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 547)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100543AURGEN548",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-548",
    "asin": "B0HP5RBV3L",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 548)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100544AURGEN549",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-549",
    "asin": "B0HP61MDTT",
    "name": "No-Drill Wall-Mounted Bathroom & Kitchen Spice Storage Organizer Rack (Series 549)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100545AURGEN550",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-550",
    "asin": "B0HP5ZRGXT",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 550)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100546AURGEN551",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-551",
    "asin": "B0HP65NFRM",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 551)",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100547AURGEN552",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-552",
    "asin": "B0HP5ZL2DH",
    "name": "1.8L Borosilicate Glass & Brushed Stainless Cordless Electric Water Kettle (Series 552)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100548AURGEN553",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-553",
    "asin": "B0HP5TWRRV",
    "name": "No-Drill Wall-Mounted Bathroom & Kitchen Spice Storage Organizer Rack (Series 553)",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100549AURGEN554",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-554",
    "asin": "B0HP5MGHVT",
    "name": "9-in-1 Electric Rotating Floor Scrubber Handheld Cleaning Brush Uk – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100550AURGEN555",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-555",
    "asin": "B0HP5ZDRXJ",
    "name": "Half-high Neck Lace Short-sleeve Dress With Eyelash Trim – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100551AURGEN556",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-556",
    "asin": "B0HP65T3P2",
    "name": "Crossover Pleated Waist-cinching Halter-neck Deep Backless Dress – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100552AURGEN557",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-557",
    "asin": "B0HP5ZG6KM",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 557)",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100553AURGEN558",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-558",
    "asin": "B0HP5XSXH4",
    "name": "Fashionable Slit Bow-tie Backless Halter-neck Mini Dress – Cervical Neck, Shoulder & Back Shiatsu Kneading Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100554AURGEN559",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-559",
    "asin": "B0HP5WSD63",
    "name": "Windshield Cleaning Tablets, Glass Restoration De-fogging Wash – Stiff-Bristle Crevice, Window Track & Tile Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100555AURGEN560",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-560",
    "asin": "B0HP63M65H",
    "name": "Electric Turbo Brush Suitable For Yson V7 V8 V10 – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100556AURGEN561",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-561",
    "asin": "B0HP63FHLC",
    "name": "Precision Gooseneck Pour-Over Electric Tea & Coffee Water Boiler Kettle (Series 561)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100557AURGEN562",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-562",
    "asin": "B0HP5V9K6L",
    "name": "35 28 Modern Wall Mounted Bathroom Storage Cabinet, Bathroom – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100558AURGEN563",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-563",
    "asin": "B0HP61BNJJ",
    "name": "Barn-180 130cm Electric Blanket Camel Color Uk – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100559AURGEN564",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-564",
    "asin": "B0HP5S5KVM",
    "name": "Large Black Gold Brown Fur Crosshead Brush Daily Blush",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100560AURGEN565",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-565",
    "asin": "B0HP61263Y",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 565)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100561AURGEN566",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-566",
    "asin": "B0HP5X2RXT",
    "name": "Electric Concentric Polishing Machine Set Yellow Luxury Accessory – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 58.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100562AURGEN567",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-567",
    "asin": "B0HP5ZBRQH",
    "name": "Red 24v Electric Go Kart Dual 150w Motors, Adjustable – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100563AURGEN568",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-568",
    "asin": "B0HP5RF52J",
    "name": "Glass Cleaning Board, Windshield Restoration Oil Film Decontamination – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100564AURGEN569",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-569",
    "asin": "B0HP5TPQYF",
    "name": "Windshield Oil Film Effervescent Tablets, Glass Stain Cleaning Tabs – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100565AURGEN570",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-570",
    "asin": "B0HP5PGWRC",
    "name": "Glass Cleaning Brush, Degreaser Waterproof Windshield Rain Brush",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100566AURGEN571",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-571",
    "asin": "B0HP5RGXR5",
    "name": "Car Water Spot Remover, Glass Cleaning Tablets, Mirror Bathroom – Long-Reach Bristle Scrubber & Household Cleaning Brush",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100567AURGEN572",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-572",
    "asin": "B0HP5RZZ4G",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 572)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100568AURGEN573",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-573",
    "asin": "B0HP5ZX8Q1",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 573)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100569AURGEN574",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-574",
    "asin": "B0HP5PCZHZ",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 574)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100570AURGEN575",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-575",
    "asin": "B0HP5TQMRF",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 575)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100571AURGEN576",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-576",
    "asin": "B0HP5Z6RRH",
    "name": "Universal Car Trunk Rear Storage Bag Organizer Box Multifunctional",
    "price": 80.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100572AURGEN577",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-577",
    "asin": "B0HP5WS93R",
    "name": "Engine Degreaser Cleaner, Glass Degreaser, Decontamination Waterproof Windshield Rain – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100573AURGEN578",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-578",
    "asin": "B0HP5XQHTL",
    "name": "Portable 3-tier Rolling Makeup Case With Universal Wheels For – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100574AURGEN579",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-579",
    "asin": "B0HP5ZZW3D",
    "name": "72 Black Kitchen Pantry Storage Cabinet With Hutch, Large – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100575AURGEN580",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-580",
    "asin": "B0HP5TWXRQ",
    "name": "Beard Brush Men Beard Growth Roller Stainless Steel Microneedle",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100576AURGEN581",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-581",
    "asin": "B0HP63WPF8",
    "name": "47pcs Cordless Charging Electric Screwdriver Set – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100577AURGEN582",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-582",
    "asin": "Pending ASIN",
    "name": "Cosmetic Powder With Brush Pink Makeup Feeling Natural Light",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100578AURGEN583",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-583",
    "asin": "B0HP5PGLKV",
    "name": "Electric Motorcycle – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100579AURGEN584",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-584",
    "asin": "B0HP63GZD5",
    "name": "4-tire Garden Greenhouse Staging Storage Shelving-double Pack – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100580AURGEN585",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-585",
    "asin": "B0HP5ZDR4T",
    "name": "2-in-1 Car Cooling And Heating Fan 24v 200w Car – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100581AURGEN586",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-586",
    "asin": "B0HP5WWP4T",
    "name": "Blue 12v Kids Ride On Utv Truck Battery Powered – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100582AURGEN587",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-587",
    "asin": "B0HP646P6Z",
    "name": "Women Mock-neck Double-zip Laid-back Style Knit Sweater – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100583AURGEN588",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-588",
    "asin": "B0HP5PHL47",
    "name": "Womens Double-sided Fleece-lined Mock-neck Cape Top And Wide-leg Pants – Rechargeable Meridian & Muscle Relief Massager",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100584AURGEN589",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-589",
    "asin": "B0HP612CXQ",
    "name": "Storage Cabinet For Backyard Pool Area, 3-drawer Wicker Towel – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100585AURGEN590",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-590",
    "asin": "B0HP5Z9CQ6",
    "name": "Nail Art Color Brush Set Fine Tip Outlining Quick-drying",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100586AURGEN591",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-591",
    "asin": "B0HP5RLRS3",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 591)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100587AURGEN592",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-592",
    "asin": "B0HP5PQ6FK",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 592)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100588AURGEN593",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-593",
    "asin": "B0HP5V3FP9",
    "name": "Kids Bookcase With Collapsible Fabric Drawers, Children Book Display, – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100589AURGEN594",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-594",
    "asin": "B0HP5RDS5G",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 594)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100590AURGEN595",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-595",
    "asin": "B0HP65T3P3",
    "name": "Shoe Bench, Retro Shoe Storage Bench With Safe Soft-close – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100591AURGEN596",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-596",
    "asin": "B0HP5WYZ3J",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 596)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100592AURGEN597",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-597",
    "asin": "B0HP5X5NHP",
    "name": "Electric Water Bottle Pump Usb Rechargeable Automatic Drinking Water",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100593AURGEN598",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-598",
    "asin": "Pending ASIN",
    "name": "100lb Home Gym Sets Multi-functional Power Cage,home Adjustable Pullup – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100594AURGEN599",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-599",
    "asin": "B0HP63L3VT",
    "name": "Women Solid Color High-neck Vintage Sheath Dress – Full-Body Deep Kneading Roller & Muscle Recovery Massager",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100595AURGEN600",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-600",
    "asin": "B0HP5PT93K",
    "name": "Cleaning Paste For Oven And Baking Tray – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100596AURGEN601",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-601",
    "asin": "Pending ASIN",
    "name": "Barn-180 130cm Electric Blanket Gray Uk – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100597AURGEN602",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-602",
    "asin": "B0HP5V3QHC",
    "name": "210lb Home Gym Sets Multi-functional Power Cage,home Adjustable Pullup – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100598AURGEN603",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-603",
    "asin": "B0HP63XWJK",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 603)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100599AURGEN604",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-604",
    "asin": "B0HP5TSXM8",
    "name": "Women Round-neck Loose Casual Dress And Hair Accessory Set – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100600AURGEN605",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-605",
    "asin": "B0HP5RHXQ6",
    "name": "Soft Dog Travel Crate,grey,collapsible Dog Crate 3-door Durable Mesh – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100601AURGEN606",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-606",
    "asin": "B0HP5Z28Z5",
    "name": "Fishing Cart Beach Cart Collapsible Wagon 85 All-terrain Wheels – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100602AURGEN607",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-607",
    "asin": "B0HP5XFVZS",
    "name": "Electric Clothes Dryer Portable Buddy Fast Hot Air Drying – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100603AURGEN608",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-608",
    "asin": "B0HP5ZL6FH",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 608)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100604AURGEN609",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-609",
    "asin": "B0HP5ZCYLR",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 609)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100605AURGEN610",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-610",
    "asin": "B0HP5WRL7T",
    "name": "Men Beard Brush Mustache Grooming Brush Plastic Handle Nylon",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100606AURGEN611",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-611",
    "asin": "B0HP5WYWQ5",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 611)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100607AURGEN612",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-612",
    "asin": "B0HP639SSC",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 612)",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100608AURGEN613",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-613",
    "asin": "B0HP5TNTTN",
    "name": "Children Plush Toy Walking Electric Dog – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 33.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100609AURGEN614",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-614",
    "asin": "B0HP66GSXY",
    "name": "Uk Barn Electric Back Pad – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 49.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100610AURGEN615",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-615",
    "asin": "B0HP5RRVN8",
    "name": "Pulsating Electric Cow Milking Machine – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100611AURGEN616",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-616",
    "asin": "B0HP5X5L5V",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 616)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100612AURGEN617",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-617",
    "asin": "B0HP5VBRHC",
    "name": "Women Deep Neck Sequin Evening Gown Elegant Long Dress – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100613AURGEN618",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-618",
    "asin": "B0HP5MHPCT",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 618)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100614AURGEN619",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-619",
    "asin": "B0HP5TQ57H",
    "name": "1.7L Fast-Boil Stainless & Borosilicate Cordless Electric Kettle (619 Pro Series)",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100615AURGEN620",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-620",
    "asin": "B0HP5VB4RY",
    "name": "Multi-Tier Wall & Countertop Storage Shelf Organizer Rack (620 Pro Series)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100616AURGEN621",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-621",
    "asin": "Pending ASIN",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 621)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100617AURGEN622",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-622",
    "asin": "B0HP5X7583",
    "name": "Electric Toy Frog With Omnidirectional Blowing Ball – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100618AURGEN623",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-623",
    "asin": "B0HP5S4PQ9",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 623)",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100619AURGEN624",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-624",
    "asin": "B0HP5YWGY3",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 624)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100620AURGEN625",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-625",
    "asin": "B0HP5RFG9X",
    "name": "Electric Glowing Police Car Engineering Toy Car – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100621AURGEN626",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-626",
    "asin": "B0HP63LDCK",
    "name": "Metal Racking Shelf Storage180x100x40cm Shelving 70 86in Hx39 37 (Ergonomic Non-Slip Grip · 626 Series)",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100622AURGEN627",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-627",
    "asin": "B0HP65NHTD",
    "name": "3ft Rectangular Outdoor Folding Table, 40cm Width, Aluminum Frame, – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100623AURGEN628",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-628",
    "asin": "B0HP5ZSRWV",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 628)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100624AURGEN629",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-629",
    "asin": "B0HP5RZVZK",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 629)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100625AURGEN630",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-630",
    "asin": "B0HP65QJ29",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 630)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100626AURGEN631",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-631",
    "asin": "B0HP65TPKS",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 631)",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100627AURGEN632",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-632",
    "asin": "B0HP5XGS3H",
    "name": "Electric Rotating Acrylic Display Stand Tube Swing Rack For – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100628AURGEN633",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-633",
    "asin": "B0HP5VJ7QP",
    "name": "Electric Light Music Recording And Talking Interactive Toy – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100629AURGEN634",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-634",
    "asin": "Pending ASIN",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 634)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100630AURGEN635",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-635",
    "asin": "B0HP5RKL9D",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 635)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100631AURGEN636",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-636",
    "asin": "B0HP626S3Y",
    "name": "Retro Boat-neck Flared-sleeve Mini Dress Stretchy And Figure-hugging – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100632AURGEN637",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-637",
    "asin": "B0HP65RMPJ",
    "name": "Women Printed Round Neck Pullover Long Sleeve T-shirt – Handheld Skin Toning & Target Points Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100633AURGEN638",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-638",
    "asin": "B0HP65Y4J2",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 638)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100634AURGEN639",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-639",
    "asin": "B0HP5TNVZN",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 639)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100635AURGEN640",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-640",
    "asin": "B0HP63ZB35",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 640)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100636AURGEN641",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-641",
    "asin": "B0HP5RFG9Y",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 641)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100637AURGEN642",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-642",
    "asin": "B0HP643D4M",
    "name": "Cifbuy 2d Flat Metal Wall Plaque Retro Parking Sign, – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100638AURGEN643",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-643",
    "asin": "B0HP5PQ95H",
    "name": "Kids Table And Chair Set, In Wooden Activity Table – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100639AURGEN644",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-644",
    "asin": "B0HP5PHWH4",
    "name": "Foldable Car Door Cup Holder, Retractable Water Bottle Bracket, – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100640AURGEN645",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-645",
    "asin": "B0HP613C72",
    "name": "Electric Heated Foot Mat For Under Desk, Large Area – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100641AURGEN646",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-646",
    "asin": "B0HP5RC25C",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 646)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100642AURGEN647",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-647",
    "asin": "B0HP68F8N2",
    "name": "Kids Toy Storage Organizer With Bins, Multi-functional Nursery Organizer",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100643AURGEN648",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-648",
    "asin": "B0HP65RLW7",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 648)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100644AURGEN649",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-649",
    "asin": "B0HP5RWZDM",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 649)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100645AURGEN650",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-650",
    "asin": "B0HP63W3KF",
    "name": "Electric Pressure Washer, Max 4200 Psi And Gpm High – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100646AURGEN651",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-651",
    "asin": "B0HP619YGB",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 651)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100647AURGEN652",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-652",
    "asin": "B0HP5YVL67",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 652)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100648AURGEN653",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-653",
    "asin": "B0HP5Z18KW",
    "name": "Metal Racking Shelf Storage180x100x40cm Shelving 70 86in Hx39 37 (Reinforced Heavy-Duty Pro · 653 Series)",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100649AURGEN654",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-654",
    "asin": "B0HP5RNS5F",
    "name": "Potting Bench With Storage Cabinet And Metal Table Top – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100650AURGEN655",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-655",
    "asin": "B0HP6414BV",
    "name": "Sexy Lace-printed Flared-sleeve High-neck Hollow-out Dress – Full-Body Deep Kneading Roller & Muscle Recovery Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100651AURGEN656",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-656",
    "asin": "B0HP5ZLV3J",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 656)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100652AURGEN657",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-657",
    "asin": "B0HP5Z98S2",
    "name": "Electric Screwdriver Set Bits Usb Rechargeable Cordless Lithium Battery – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 56.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100653AURGEN658",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-658",
    "asin": "B0HP5PT343",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 658)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100654AURGEN659",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-659",
    "asin": "B0HP5WQZBB",
    "name": "Remote-controlled Bionic Flapping-wing Butterfly Electric Toy – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100655AURGEN660",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-660",
    "asin": "B0HP5S55W6",
    "name": "5-layer 2all-mounted Density Board Iron Frame Display Rack 24",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100656AURGEN661",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-661",
    "asin": "B0HP5PCDWH",
    "name": "Stainless Steel Cheese Storage Box With Cheddar Wood Design – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100657AURGEN662",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-662",
    "asin": "B0HP5S1Z39",
    "name": "Console Table/sofa Table With Storage Drawers And Bottom Shelf",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100658AURGEN663",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-663",
    "asin": "Pending ASIN",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 663)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100659AURGEN664",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-664",
    "asin": "B0HP65RLWD",
    "name": "Bathroom Triangular Storage Rack Bathroom Shelf – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100660AURGEN665",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-665",
    "asin": "B0HP5ZC2M4",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 665)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100661AURGEN666",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-666",
    "asin": "Pending ASIN",
    "name": "Usb Electric Portable Shoulder And Neck Massager Foot Massager – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100662AURGEN667",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-667",
    "asin": "B0HP5RZF48",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 667)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100663AURGEN668",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-668",
    "asin": "B0HP611Z7T",
    "name": "Halter-neck Cutout Figure-hugging Camisole Bodysuit – Rechargeable Meridian & Muscle Relief Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100664AURGEN669",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-669",
    "asin": "B0HP5PQH8X",
    "name": "Storage Appliances Punch-free Hanging Wire Device – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100665AURGEN670",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-670",
    "asin": "B0HP5RR5XV",
    "name": "Boho Tv Stand For 65, 75, 85 Inch Tv, – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100666AURGEN671",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-671",
    "asin": "B0HP5ZWHDL",
    "name": "12v Dc Submersible Water Pump For Rv Caravan Trailer",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100667AURGEN672",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-672",
    "asin": "Pending ASIN",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 672)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100668AURGEN673",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-673",
    "asin": "B0HP64M2V8",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 673)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100669AURGEN674",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-674",
    "asin": "B0HP5XF63H",
    "name": "Home-use Squat Barbell Rack Fitness Equipment – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100670AURGEN675",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-675",
    "asin": "B0HP5V3GZJ",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 675)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100671AURGEN676",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-676",
    "asin": "B0HP63THNG",
    "name": "Dedicated Household Clothing Storage Bag – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100672AURGEN677",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-677",
    "asin": "B0HP5TZTNS",
    "name": "Women Fashionable Casual Round-neck Tassel Skirt Set – Handheld Skin Toning & Target Points Body Massager",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100673AURGEN678",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-678",
    "asin": "B0HP5PRZ25",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 678)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100674AURGEN679",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-679",
    "asin": "B0HP5RWHJX",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 679)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100675AURGEN680",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-680",
    "asin": "B0HP5VD7SQ",
    "name": "Simple Multi-functional Clothes Rack For Home Use",
    "price": 65.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100676AURGEN681",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-681",
    "asin": "B0HP5PCXH1",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 681)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100677AURGEN682",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-682",
    "asin": "B0HP5ZMX95",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 682)",
    "price": 27.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100678AURGEN683",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-683",
    "asin": "B0HP6421TQ",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 683)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100679AURGEN684",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-684",
    "asin": "B0HP5V1J9C",
    "name": "Walnut Multi Purpose Toothbrush Storage Rack – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100680AURGEN685",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-685",
    "asin": "B0HP5PCZJC",
    "name": "Women Poodle Jacquard Embroidered Crew-neck Sweater – Handheld Skin Toning & Target Points Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100681AURGEN686",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-686",
    "asin": "Pending ASIN",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 686)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100682AURGEN687",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-687",
    "asin": "B0HP5TVTLM",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 687)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100683AURGEN688",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-688",
    "asin": "B0HP5WVSXK",
    "name": "Womens Solid-color Round-neck Off-shoulder Plush Knit Short-sleeve Top – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100684AURGEN689",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-689",
    "asin": "B0HP5PFZJK",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 689)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100685AURGEN690",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-690",
    "asin": "B0HP5V3BLC",
    "name": "Electric Multi-function Food Processor Automatic Meat Grinder And Blender – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100686AURGEN691",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-691",
    "asin": "B0HP5YVNV7",
    "name": "Kids Bookshelf Toy Organizer Front Facing Book Display Storage",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100687AURGEN692",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-692",
    "asin": "Pending ASIN",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 692)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100688AURGEN693",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-693",
    "asin": "Pending ASIN",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 693)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100689AURGEN694",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-694",
    "asin": "B0HP5RBNPJ",
    "name": "Women Thickened Crew-neck Pullover Sweatshirt – Cervical Neck, Shoulder & Back Shiatsu Kneading Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100690AURGEN695",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-695",
    "asin": "B0HP618NPK",
    "name": "Electric Leg Massager With Air Compression And Heat Foot – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100691AURGEN696",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-696",
    "asin": "B0HP5V5RHJ",
    "name": "4-68 Lift Range Electric Adjustable Bed Backrest, 300 Lbs – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100692AURGEN697",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-697",
    "asin": "Pending ASIN",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 697)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100693AURGEN698",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-698",
    "asin": "B0HP5Z4YYB",
    "name": "Remote-controlled Electric Cobra Model With Movable Joints And Lights – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100694AURGEN699",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-699",
    "asin": "B0HP5YYJHB",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 699)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100695AURGEN700",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-700",
    "asin": "B0HP688W1P",
    "name": "Electric Light Music Recording And Talking Interactive Toy – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100696AURGEN701",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-701",
    "asin": "B0HP5RXZ13",
    "name": "No-Drill Wall-Mounted Bathroom & Kitchen Spice Storage Organizer Rack (Series 701)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100697AURGEN702",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-702",
    "asin": "B0HP5PRBNF",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 702)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100698AURGEN703",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-703",
    "asin": "B0HP63LZG7",
    "name": "Home-use Small Electric Stepper Machine – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100699AURGEN704",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-704",
    "asin": "B0HP5PCWMT",
    "name": "Electric Bikini Trimmer For Women, In Dual Head Painless – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100700AURGEN705",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-705",
    "asin": "B0HP63L3TL",
    "name": "Round Neck Multicolor Lace-up Ruffled Plus Size Dress – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100701AURGEN706",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-706",
    "asin": "B0HP611VTK",
    "name": "Crew-neck Pullover Sweater Korean-style Workwear Outfit – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100702AURGEN707",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-707",
    "asin": "B0HP5V24PZ",
    "name": "Remote Control Electric Programming Robotic Arm Building Blocks Kit – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100703AURGEN708",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-708",
    "asin": "B0HP5Z1VL4",
    "name": "350 Lbs Portable Table Saw Stand, Rolling Foldable Heavy – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100704AURGEN709",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-709",
    "asin": "B0HP5Z2YBT",
    "name": "Laid-back Wide-sleeved Relaxed-fit Slimming Crew-neck Outer Sweater – Handheld Skin Toning & Target Points Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100705AURGEN710",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-710",
    "asin": "B0HP5Z336D",
    "name": "Kitchen Storage Cabinet – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100706AURGEN711",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-711",
    "asin": "B0HP5Z2L18",
    "name": "Cifbuy Vintage Black Iron Wall Hook Set, Distressed Finish – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100707AURGEN712",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-712",
    "asin": "B0HP5PMZMX",
    "name": "Kitchen Storage Cabinet – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100708AURGEN713",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-713",
    "asin": "B0HP64JQWX",
    "name": "Teeth Care 10ml Deep Cleaning Refreshing Gentle Formula For – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100709AURGEN714",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-714",
    "asin": "B0HP65VWPY",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 714)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100710AURGEN715",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-715",
    "asin": "B0HP618GKW",
    "name": "Rustic Brown Narrow Shoe Storage Cabinet Flip Drawers Design, – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100711AURGEN716",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-716",
    "asin": "B0HP5WW94N",
    "name": "Loose-fit Puff-sleeve Round-neck Pleated Mini Dress – Rechargeable Meridian & Muscle Relief Massager",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100712AURGEN717",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-717",
    "asin": "B0HP5XJYZW",
    "name": "Women Versatile Rhinestone-embellished Mock-neck Sweater – Handheld Skin Toning & Target Points Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100713AURGEN718",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-718",
    "asin": "B0HP5ZYSHH",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 718)",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100714AURGEN719",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-719",
    "asin": "B0HP5Z6KKG",
    "name": "Yellow Toddler Excavator Toy Anti-tip Design, Manual Shovel, Horn, – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100715AURGEN720",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-720",
    "asin": "B0HP5RN2V3",
    "name": "32a 7kw Ev Charger Type Electric Car Charging Station – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100716AURGEN721",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-721",
    "asin": "Pending ASIN",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 721)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100717AURGEN722",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-722",
    "asin": "B0HP5XCHGC",
    "name": "Women Solid-color Three-quarter-sleeve Round-neck Loose-fitting Short-sleeve Top – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100718AURGEN723",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-723",
    "asin": "B0HP61Y5M5",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 723)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100719AURGEN724",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-724",
    "asin": "B0HP5VJ7QW",
    "name": "Cat Bookshelf Cabinet Organized Storage Sections Multiple Climbing Platforms – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100720AURGEN725",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-725",
    "asin": "B0HP6155NB",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 725)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100721AURGEN726",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-726",
    "asin": "B0HP5XHVVF",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 726)",
    "price": 50.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100722AURGEN727",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-727",
    "asin": "Pending ASIN",
    "name": "Electric Fascia Ring Multifunctional Full Body Muscle Massager With – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100723AURGEN728",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-728",
    "asin": "Pending ASIN",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 728)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100724AURGEN729",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-729",
    "asin": "B0HP5XQ6XT",
    "name": "Oral Care 1-piece Deep Cleaning Enamel Protection Protector For – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100725AURGEN730",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-730",
    "asin": "B0HP5X6DB4",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 730)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100726AURGEN731",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-731",
    "asin": "B0HP5PGWRL",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 731)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100727AURGEN732",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-732",
    "asin": "B0HP5YWD5K",
    "name": "Cube Open Storage Bookshelf With Heavy-duty Metal Elevated Legs, – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100728AURGEN733",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-733",
    "asin": "B0HP5RVZJQ",
    "name": "Dtl-6000w 60cm Ceramic Hob Zone Black Glass Built-in Electric – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100729AURGEN734",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-734",
    "asin": "B0HP5V1QXB",
    "name": "Round-neck Ribbed Midi Bodycon Knit Dress – Cervical Neck, Shoulder & Back Shiatsu Kneading Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100730AURGEN735",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-735",
    "asin": "B0HP5PK6HL",
    "name": "Zone Electric Hot Plate Cooker 1800w-1000w Double Hob Portable – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100731AURGEN736",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-736",
    "asin": "B0HP61MCY6",
    "name": "Kitchen Storage Cabinet – Wall-Mounted Storage Shelf Organizer Rack (Ergonomic Non-Slip Grip · 736 Series)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100732AURGEN737",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-737",
    "asin": "B0HP5RK6JJ",
    "name": "Women Casual Round Neck Half Sleeve T-shirt – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100733AURGEN738",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-738",
    "asin": "B0HP5V44NS",
    "name": "Electric Fascia Ring Massager Heat Modes Levels Rechargeable Type C – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 50.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100734AURGEN739",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-739",
    "asin": "Pending ASIN",
    "name": "Pcp Air Compressor Pump 4500psi 30mpa High Pressure Electric – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100735AURGEN740",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-740",
    "asin": "B0HP5PQ34G",
    "name": "Freestanding Hammock With Stand, 600lbs Heavy Duty Outdoor Hammock – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100736AURGEN741",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-741",
    "asin": "B0HP5PL44V",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 741)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100737AURGEN742",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-742",
    "asin": "B0HP68HVYK",
    "name": "Rapid-Boil Double-Wall Insulated Countertop Electric Hot Water Kettle (Series 742)",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100738AURGEN743",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-743",
    "asin": "B0HP5MH366",
    "name": "Cifbuy Vintage Gothic Iron Wall Shelf With Hooks, Space",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100739AURGEN744",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-744",
    "asin": "B0HP5TNMTG",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 744)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100740AURGEN745",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-745",
    "asin": "B0HP5RJV3C",
    "name": "24 14 16 Inch Underbody Truck Storage Box Plate – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100741AURGEN746",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-746",
    "asin": "B0HP5ZMFQM",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 746)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100742AURGEN747",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-747",
    "asin": "B0HP5Z8NFQ",
    "name": "Cifbuy Pack Industrial Black Metal Wall Hooks Heavy Duty – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100743AURGEN748",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-748",
    "asin": "Pending ASIN",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 748)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100744AURGEN749",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-749",
    "asin": "B0HP6367B3",
    "name": "Electric Radiator Cooling Fan Fit For Hyundai Sonata 2011-14 – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100745AURGEN750",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-750",
    "asin": "B0HP5XBHBJ",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 750)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100746AURGEN751",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-751",
    "asin": "B0HP5RHQZB",
    "name": "350w Electric Pottery Wheel Turntable Ceramic Forming Machine For – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100747AURGEN752",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-752",
    "asin": "B0HP5V6RGF",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 752)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100748AURGEN753",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-753",
    "asin": "B0HP5PDJ7X",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 753)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100749AURGEN754",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-754",
    "asin": "B0HP65V6NS",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 754)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100750AURGEN755",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-755",
    "asin": "B0HP66VBZT",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 755)",
    "price": 31.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100751AURGEN756",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-756",
    "asin": "B0HP5VH1DS",
    "name": "Cifbuy Sleek Wall Mounted Metal Key Holder With Hooks, – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100752AURGEN757",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-757",
    "asin": "B0HP5XJGTD",
    "name": "12v 3000lbs Electric Winch Steel Cable Truck Trailer Towing – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100753AURGEN758",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-758",
    "asin": "B0HP5V7K1B",
    "name": "U-shaped Electric Toothbrush With Soft Fine Bristles For Babies – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100754AURGEN759",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-759",
    "asin": "B0HP5RZ6BN",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 759)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100755AURGEN760",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-760",
    "asin": "B0HP5XRDVS",
    "name": "Kitchen Single Electric Induction Hob Portable Table Top Cooker – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100756AURGEN761",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-761",
    "asin": "B0HP5TSJS2",
    "name": "Brown Entryway Shoe Storage Bench Padded Seat With Rattan – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100757AURGEN762",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-762",
    "asin": "B0HP5RZW13",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 762)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100758AURGEN763",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-763",
    "asin": "B0HP5X8SF5",
    "name": "Electric Scooter Throttle Handle With Lcd Speed Display Universal – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100759AURGEN764",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-764",
    "asin": "B0HP5WYCVD",
    "name": "Teeth Cleaning Mousse 60ml Refreshing Portable Travel Size Gentle – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100760AURGEN765",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-765",
    "asin": "B0HP5X48TX",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 765)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100761AURGEN766",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-766",
    "asin": "B0HP65R41M",
    "name": "Hooded Electric Heating Body-warming Blanket Usb Heated Shawl – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100762AURGEN767",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-767",
    "asin": "B0HP5V8TS3",
    "name": "Cifbuy Heavy Duty Stainless Steel Wall Hooks, Rustproof Multifunctional – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100763AURGEN768",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-768",
    "asin": "B0HP5XBD71",
    "name": "50l Electric Hot Water Heater Vertical Household Storage Tank",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100764AURGEN769",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-769",
    "asin": "B0HP65918R",
    "name": "Cifbuy Vintage Coonhound Wall-mounted Coat Rack With Leash Hanger",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100765AURGEN770",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-770",
    "asin": "B0HP5RHV7V",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 770)",
    "price": 50.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100766AURGEN771",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-771",
    "asin": "B0HP5X7SPV",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 771)",
    "price": 55.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100767AURGEN772",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-772",
    "asin": "B0HP5XJGTF",
    "name": "Children Fishing Spinning Candy Box Electric Educational Early Learning – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100768AURGEN773",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-773",
    "asin": "B0HP63CWGF",
    "name": "7000w Built-in Touch Control Electric Induction Ceramic Hob Zone – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100769AURGEN774",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-774",
    "asin": "B0HP5RN66K",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 774)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100770AURGEN775",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-775",
    "asin": "B0HP63DSKZ",
    "name": "Winter Warm Outdoor Cycling Electric-heated Windproof Waterproof Touchscreen Heating – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100771AURGEN776",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-776",
    "asin": "B0HP5VCXZL",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 776)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100772AURGEN777",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-777",
    "asin": "B0HP5RZW14",
    "name": "Cifbuy Farmhouse Black Iron Wall Mounted Coat Rack With",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100773AURGEN778",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-778",
    "asin": "B0HP5WT32H",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 778)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100774AURGEN779",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-779",
    "asin": "B0HP6122RG",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 779)",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100775AURGEN780",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-780",
    "asin": "B0HP5XGH1C",
    "name": "Cifbuy Moon Shaped Floating Wall Shelf With Cat Hooks,",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100776AURGEN781",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-781",
    "asin": "B0HP5WQ3F7",
    "name": "Cifbuy Gothic Rustproof Iron Wreath Holder For Front Door, – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100777AURGEN782",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-782",
    "asin": "B0HP5WVYWQ",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 782)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100778AURGEN783",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-783",
    "asin": "B0HP5RN66L",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 783)",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100779AURGEN784",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-784",
    "asin": "B0HP65BZSM",
    "name": "Electric Food Vacuum Sealer Automatic Dry Wet Sealing Packaging – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100780AURGEN785",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-785",
    "asin": "B0HP5YZYG6",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 785)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100781AURGEN786",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-786",
    "asin": "B0HP63THNT",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 786)",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100782AURGEN787",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-787",
    "asin": "B0HP5WZL5C",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 787)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100783AURGEN788",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-788",
    "asin": "B0HP5TX4GB",
    "name": "Teeth Cleaning 15ml Stain Removal Fresh Breath Enamel Protection – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100784AURGEN789",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-789",
    "asin": "B0HP5WVD69",
    "name": "No-Drill Wall-Mounted Bathroom & Kitchen Spice Storage Organizer Rack (Series 789)",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100785AURGEN790",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-790",
    "asin": "B0HP5TVTM6",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 790)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100786AURGEN791",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-791",
    "asin": "B0HP5S1H3R",
    "name": "600ml Collapsible Travel Electric Water Kettle Folding Camping Caravan",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100787AURGEN792",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-792",
    "asin": "B0HP5V6RGQ",
    "name": "1.8L Borosilicate Glass & Brushed Stainless Cordless Electric Water Kettle (Series 792)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100788AURGEN793",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-793",
    "asin": "B0HP5S5PX2",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 793)",
    "price": 25.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100789AURGEN794",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-794",
    "asin": "B0HP65JWZM",
    "name": "4-in-1 Kids Art Easel With Marble Run, Adjustable Height – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100790AURGEN795",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-795",
    "asin": "B0HP5Z5GWS",
    "name": "Heavy-Duty Ergonomic Kitchen & Bath Scrubbing Cleaning Brush (795 Pro Series)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100791AURGEN796",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-796",
    "asin": "B0HP5S4NXQ",
    "name": "Plastic Sealed Storage Tanks Uk – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100792AURGEN797",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-797",
    "asin": "B0HP65MPVB",
    "name": "Electric Small Mini Rechargeable Desktop Vacuum Cleaner – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100793AURGEN798",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-798",
    "asin": "B0HP5XDB1Q",
    "name": "Polka Dot Square Neck Waist-cinching Long Sleeve Chiffon Dress – Cervical Neck, Shoulder & Back Shiatsu Kneading Massager",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100794AURGEN799",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-799",
    "asin": "B0HP5YY5Z6",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 799)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100795AURGEN800",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-800",
    "asin": "Pending ASIN",
    "name": "Pet Feeder Station Storage Cabinet – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100796AURGEN801",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-801",
    "asin": "B0HP5Z1JM7",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 801)",
    "price": 40.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100797AURGEN802",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-802",
    "asin": "B0HP65M6M4",
    "name": "Teeth Cleaning 15ml Fresh Breath Tartar Control Refreshing Hydrating – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100798AURGEN803",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-803",
    "asin": "B0HP5X1SQZ",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 803)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100799AURGEN804",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-804",
    "asin": "B0HP612P46",
    "name": "Uk Barn Card A4 Storage Book 540 Compartments Black – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100800AURGEN805",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-805",
    "asin": "Pending ASIN",
    "name": "Deep Tissue Shiatsu Neck, Back & Body Recovery Massager (805 Pro Series)",
    "price": 33.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100801AURGEN806",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-806",
    "asin": "B0HP5WSM25",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 806)",
    "price": 30.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100802AURGEN807",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-807",
    "asin": "B0HP5RVLD2",
    "name": "Cross-border Eu-standard Electric Kettle For Home Use",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100803AURGEN808",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-808",
    "asin": "Pending ASIN",
    "name": "Multi-functional Electric Head Massage Comb With Wireless Red-light Hair – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100804AURGEN809",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-809",
    "asin": "B0HP5TN56V",
    "name": "Electric Heating Negative Pressure Hot Compress Red Light Cupping – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100805AURGEN810",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-810",
    "asin": "B0HP5TZ7LN",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 810)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100806AURGEN811",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-811",
    "asin": "B0HP65VLMM",
    "name": "Shoe Storage Cabine – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100807AURGEN812",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-812",
    "asin": "Pending ASIN",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 812)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100808AURGEN813",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-813",
    "asin": "B0HP5ZBD8L",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 813)",
    "price": 36.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100809AURGEN814",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-814",
    "asin": "B0HP5X8WBB",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 814)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100810AURGEN815",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-815",
    "asin": "B0HP5TXJK9",
    "name": "Electric Water Pump Circulation Pump Fits For Webasto Thermo",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100811AURGEN816",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-816",
    "asin": "B0HP5ZXGX7",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 816)",
    "price": 53.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100812AURGEN817",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-817",
    "asin": "B0HP6BHZYN",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 817)",
    "price": 26.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100813AURGEN818",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-818",
    "asin": "B0HP65P3RN",
    "name": "Linen And Paper Yarnsummer Thin Hollow-out Knit Cardigan – Portable Soothing Heat & Vibration Therapy Massager",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100814AURGEN819",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-819",
    "asin": "B0HP621RN8",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 819)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100815AURGEN820",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-820",
    "asin": "B0HP5RW1ZW",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 820)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100816AURGEN821",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-821",
    "asin": "B0HP5PJDQN",
    "name": "Sweet And Cool Spicy Girl Short Skirt, European And – Handheld Skin Toning & Target Points Body Massager",
    "price": 34.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100817AURGEN822",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-822",
    "asin": "B0HP5Z8YV1",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 822)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100818AURGEN823",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-823",
    "asin": "B0HP5ZHNKK",
    "name": "Home Office Dual Desktop Desk With Storage Drawers, Powder-coated – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100819AURGEN824",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-824",
    "asin": "Pending ASIN",
    "name": "Cifbuy Modern Matte Black Wall Mounted Steel Rack With",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100820AURGEN825",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-825",
    "asin": "B0HP5TYTCN",
    "name": "Christmas Inflatable Black Santa Playing Electric Guitar With Led – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100821AURGEN826",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-826",
    "asin": "B0HP61ZCGS",
    "name": "Relaxing Electric Back Heat Pad Wrap For Muscle Tension – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100822AURGEN827",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-827",
    "asin": "B0HP5PC6W8",
    "name": "Kitchen Storage Cabinet – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100823AURGEN828",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-828",
    "asin": "Pending ASIN",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 828)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100824AURGEN829",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-829",
    "asin": "B0HP5VGJRR",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 829)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100825AURGEN830",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-830",
    "asin": "B0HP5PLM1F",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 830)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100826AURGEN831",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-831",
    "asin": "B0HP5PT6BV",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 831)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100827AURGEN832",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-832",
    "asin": "B0HP636SGJ",
    "name": "Perfume Angels Evening Niche Fragrance Women Neck Wrist Carry – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100828AURGEN833",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-833",
    "asin": "B0HP5ZL2FC",
    "name": "Drying Rack Gray Plastic Parts Uk – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 58.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100829AURGEN834",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-834",
    "asin": "B0HP5XM8Z8",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 834)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100830AURGEN835",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-835",
    "asin": "B0HP5TQ7VC",
    "name": "Electric Foot Grinder, Automatic Foot Rubbing, Calluses Removal, And – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100831AURGEN836",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-836",
    "asin": "B0HP6763W8",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 836)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100832AURGEN837",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-837",
    "asin": "B0HP5WV91H",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 837)",
    "price": 55.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100833AURGEN838",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-838",
    "asin": "B0HP5X9WFC",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 838)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100834AURGEN839",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-839",
    "asin": "B0HP5RC551",
    "name": "Oral Care Treatment 7ml Deep Cleaning Enamel Protection For – Stiff-Bristle Crevice, Window Track & Tile Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100835AURGEN840",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-840",
    "asin": "B0HP5X2W3S",
    "name": "6-story Bamboo Shoe Rack 107 X67 24cm Uk – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100836AURGEN841",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-841",
    "asin": "B0HP5YZ99R",
    "name": "Extension Lead Cable Electric Mains Power Gang Usb Type C – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100837AURGEN842",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-842",
    "asin": "B0HP5X7ZDL",
    "name": "Retractable Tubular Fish Tank Electric Cleaner Battery Powered Aquarium – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100838AURGEN843",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-843",
    "asin": "B0HP5RRGNG",
    "name": "Mini Led Flashlight Rechargeable Safe Protection Electric Torch Security – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100839AURGEN844",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-844",
    "asin": "Pending ASIN",
    "name": "Pink Toddler Foot-to-floor Ride-on Push Car Kids Sliding Walking – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100840AURGEN845",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-845",
    "asin": "B0HP6763WC",
    "name": "Adjustable Metal Rolling Clothes Rack With Extendable Rods, 104",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100841AURGEN846",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-846",
    "asin": "B0HP5S5CMJ",
    "name": "Car Cleaning Brush With Bendable, Adjustable Telescopic Handle And",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100842AURGEN847",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-847",
    "asin": "B0HP5VK1J1",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 847)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100843AURGEN848",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-848",
    "asin": "B0HP657QC7",
    "name": "Dental Impression Kit Deep Cleaning Comfortable Fit For Daily – Ergonomic Household Scrubbing & Cleaning Brush",
    "price": 68.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100844AURGEN849",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-849",
    "asin": "B0HP5S1Z3Q",
    "name": "Cotton Candy Machine Electric Cotton Candy Maker 450w – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100845AURGEN850",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-850",
    "asin": "B0HP5WTZ2M",
    "name": "Cordless Detail Sander Compatible With 20v Max Battery Tool – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100846AURGEN851",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-851",
    "asin": "B0HP5RSRLP",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 851)",
    "price": 50.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100847AURGEN852",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-852",
    "asin": "B0HP5RQGLW",
    "name": "In Electric Lumbar Support Pillow Smooth Spine Triple Fusion – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100848AURGEN853",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-853",
    "asin": "B0HP5ZKVF1",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 853)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100849AURGEN854",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-854",
    "asin": "B0HP5V14GJ",
    "name": "Uk Barn Brush Blower Blade Blower – 360-Degree Rotary Household & Bottle Cleaning Brush",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100850AURGEN855",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-855",
    "asin": "B0HP5WYCVM",
    "name": "Cifbuy Vintage Farmhouse Wall Mounted Entryway Hooks, Shabby Chic – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100851AURGEN856",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-856",
    "asin": "B0HP5Z9RPC",
    "name": "Electric Fuel Pump Module Assembly Fit For Ford Ranger – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100852AURGEN857",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-857",
    "asin": "B0HP686RSP",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 857)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100853AURGEN858",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-858",
    "asin": "B0HP5TN56Y",
    "name": "Cifbuy Heavy Duty Matte Black Wall Hooks Rustproof 6-hook – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100854AURGEN859",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-859",
    "asin": "B0HP5RRCRW",
    "name": "Cifbuy Stylish Minimalist Metal Wall Key Holder, Rust-resistant Space-saving – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100855AURGEN860",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-860",
    "asin": "Pending ASIN",
    "name": "1.7L Fast-Boil Stainless & Borosilicate Cordless Electric Kettle (860 Pro Series)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100856AURGEN861",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-861",
    "asin": "B0HP6559YJ",
    "name": "Electric Fascia Ring Massager Heat Modes Levels Rechargeable Type C – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100857AURGEN862",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-862",
    "asin": "B0HP5S1H48",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 862)",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100858AURGEN863",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-863",
    "asin": "B0HP5V9N13",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 863)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100859AURGEN864",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-864",
    "asin": "B0HP5Z3W1F",
    "name": "Fan Heater Portable Electric Hot Warm With Heat Settings – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 68.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100860AURGEN865",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-865",
    "asin": "B0HP5XGKT9",
    "name": "Baozi Mianmianle Translucent Concealer Pen For Face Lightweight Natural – Multi-Surface Deep Cleaning Scrubber Brush Tool",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100861AURGEN866",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-866",
    "asin": "B0HP5TTQZ6",
    "name": "Heavy-Duty Ergonomic Kitchen & Bath Scrubbing Cleaning Brush (866 Pro Series)",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100862AURGEN867",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-867",
    "asin": "B0HP5ZXGXB",
    "name": "Cotton Candy Machine Electric Cotton Candy Maker 450w Ink – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100863AURGEN868",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-868",
    "asin": "B0HP5RN94B",
    "name": "Cifbuy Rustic Farmhouse Dog Silhouette Wall Hooks Set, Heavy-duty – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100864AURGEN869",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-869",
    "asin": "B0HP5WRP58",
    "name": "Cifbuy Heavy Duty Vintage Industrial Iron Wall Hook, Rustproof – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100865AURGEN870",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-870",
    "asin": "B0HP65KDTN",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 870)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100866AURGEN871",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-871",
    "asin": "Pending ASIN",
    "name": "Cifbuy Set Of Vintage Black Metal Wall Hooks, Heavy – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100867AURGEN872",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-872",
    "asin": "B0HP5MHH5Q",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 872)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100868AURGEN873",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-873",
    "asin": "B0HP5ZM843",
    "name": "3-pack Wall-mounted Grid Wall Panels With 12 Hooks, 182 – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100869AURGEN874",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-874",
    "asin": "Pending ASIN",
    "name": "Bionic Heated Massager, Shoulder And Neck Massager With Fingers, – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 59.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100870AURGEN875",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-875",
    "asin": "B0HP5ZBNG8",
    "name": "4pcs Spice Herb Jar Rack Holder For Kitchen Door",
    "price": 37.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100871AURGEN876",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-876",
    "asin": "B0HP63QDMD",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 876)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100872AURGEN877",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-877",
    "asin": "B0HP5WZRJN",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 877)",
    "price": 46.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100873AURGEN878",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-878",
    "asin": "B0HP5Z5NG3",
    "name": "Cifbuy Vintage Wood Wall Mounted Coat Rack Hooks Farmhouse",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100874AURGEN879",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-879",
    "asin": "B0HP65R6LF",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 879)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100875AURGEN880",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-880",
    "asin": "B0HP5X48VH",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 880)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100876AURGEN881",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-881",
    "asin": "B0HP5ZNPFH",
    "name": "24v Electric Linear Actuator Fits For Rite-hite Actuator V250 – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100877AURGEN882",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-882",
    "asin": "B0HP5YWGYM",
    "name": "Googeer Kidney Clearing Detox Tea Kidney Cleaning Body Treatment – Heavy-Duty Kitchen & Bath Grout Cleaning Brush",
    "price": 62.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100878AURGEN883",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-883",
    "asin": "B0HP5Z4S3J",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 883)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100879AURGEN884",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-884",
    "asin": "B0HP5V513J",
    "name": "Washing Machine Cleaner Powder Remove Odor And Scale Build – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100880AURGEN885",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-885",
    "asin": "B0HP5PNDCP",
    "name": "Automatic Electric Hand Dryer For Commercial Hotel Mall Toilet – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 77.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100881AURGEN886",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-886",
    "asin": "B0HP63CWGX",
    "name": "Cifbuy Heavy Duty Vintage Industrial Iron Wall Hook, Rustproof – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100882AURGEN887",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-887",
    "asin": "Pending ASIN",
    "name": "Kw Fast Boiling Honeycomb Kettle Light Pink – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100883AURGEN888",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-888",
    "asin": "B0HP5WXS1R",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 888)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100884AURGEN889",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-889",
    "asin": "B0HP5TXFKT",
    "name": "Cifbuy Heavy-duty Angel Trumpet Metal Wall Hooks, Modern Farmhouse – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100885AURGEN890",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-890",
    "asin": "B0HP5RBCHZ",
    "name": "Side Table With Storage, Nightstand End Table With Floral – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100886AURGEN891",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-891",
    "asin": "Pending ASIN",
    "name": "Cute Big Eye Cat Plush Electric Hot Water Bottle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100887AURGEN892",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-892",
    "asin": "B0HP6373KB",
    "name": "Cifbuy Industrial Matte Black Wall Hook Set Heavy Duty – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100888AURGEN893",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-893",
    "asin": "B0HP5XRDWB",
    "name": "Air Fryer Household With Visible Dual Compartments Large-capacity Electric – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100889AURGEN894",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-894",
    "asin": "B0HP5MHH5X",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 894)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100890AURGEN895",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-895",
    "asin": "B0HP65KDTQ",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 895)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100891AURGEN896",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-896",
    "asin": "Pending ASIN",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 896)",
    "price": 65.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100892AURGEN897",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-897",
    "asin": "B0HP5TYTCY",
    "name": "Liquid Acne Daily Skin Treat Hydration Care Face And – Ergonomic Textured Comfort & Percussive Body Massager",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100893AURGEN898",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-898",
    "asin": "B0HP657QCB",
    "name": "Electric Pepper Grinder For Kitchen And Home Use – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100894AURGEN899",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-899",
    "asin": "B0HP5RQNXT",
    "name": "Kw Fast Boiling Honeycomb Kettle – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100895AURGEN900",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-900",
    "asin": "B0HP5PPHNW",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 900)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100896AURGEN901",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-901",
    "asin": "B0HP639LSV",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 901)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100897AURGEN902",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-902",
    "asin": "B0HP5WYX26",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 902)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100898AURGEN903",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-903",
    "asin": "B0HP65P9MG",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 903)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100899AURGEN904",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-904",
    "asin": "B0HP5TNR3B",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 904)",
    "price": 68.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100900AURGEN905",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-905",
    "asin": "B0HP5XB97G",
    "name": "Shelf Book/storage Cabinet – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100901AURGEN906",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-906",
    "asin": "B0HP5XGW1B",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 906)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100902AURGEN907",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-907",
    "asin": "B0HP5V689J",
    "name": "Wrench Organizer Modular, Detachable Tool Drawer Organizer Features Black",
    "price": 28.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100903AURGEN908",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-908",
    "asin": "B0HP5PH14K",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 908)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100904AURGEN909",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-909",
    "asin": "B0HP5RGCBQ",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 909)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100905AURGEN910",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-910",
    "asin": "B0HP5Z38XH",
    "name": "240l Water Bladder Storage Containers Foldable Pvc For Garden – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100906AURGEN911",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-911",
    "asin": "B0HP5RB7Y5",
    "name": "Electric Shaver With Light Facial Hair Remover – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100907AURGEN912",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-912",
    "asin": "Pending ASIN",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 912)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100908AURGEN913",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-913",
    "asin": "B0HP645DFG",
    "name": "Electric Smart Cat Teaser Mouse Car – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100909AURGEN914",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-914",
    "asin": "B0HP61HZ2K",
    "name": "Yellow Black No Power Excavator Toy Durable Ride On – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100910AURGEN915",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-915",
    "asin": "B0HP68G8T3",
    "name": "Cifbuy Sleek Metal Wall Mounted Key Holder And Mail – No-Drill Floating Wall Shelf & Utility Organizer Rack",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100911AURGEN916",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-916",
    "asin": "B0HP66H3V5",
    "name": "Cifbuy Heavy Duty Wrought Iron Wall Hooks, Pine Tree – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100912AURGEN917",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-917",
    "asin": "B0HP5TV1V6",
    "name": "Professional Electric Saw And Drill Plaster – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100913AURGEN918",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-918",
    "asin": "B0HP5V2BM6",
    "name": "Electric Trolleys Small Hydraulic Lifting – Smart Temperature-Control Tea & Coffee Electric Kettle",
    "price": 53.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100914AURGEN919",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-919",
    "asin": "B0HP5S62PZ",
    "name": "Shoe Storage Cabine – Rustproof Corner Shower & Vanity Storage Shelf Rack",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100915AURGEN920",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-920",
    "asin": "B0HP645RYL",
    "name": "W879 Wholesale Supplier Power Bank Hanging Hook Electric Mosquito – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100916AURGEN921",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-921",
    "asin": "B0HP5WSS4G",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 921)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100917AURGEN922",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-922",
    "asin": "B0HP5PQ6FZ",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 922)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100918AURGEN923",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-923",
    "asin": "B0HP5VJFNZ",
    "name": "W881 Outdoor Portable Product Solar Powered 1200mah Battery Electric – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100919AURGEN924",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-924",
    "asin": "B0HP657QCF",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 924)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100920AURGEN925",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-925",
    "asin": "B0HP5Z4GTJ",
    "name": "Non-Scratch Nylon Bristle Countertop, Cooktop & Sink Utility Brush (Model 925)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100921AURGEN926",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-926",
    "asin": "B0HP5RM5YF",
    "name": "Kitchen Storage Cabinet – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer (Ergonomic Non-Slip Grip · 926 Series)",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100922AURGEN927",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-927",
    "asin": "B0HP5RCJZD",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 927)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100923AURGEN928",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-928",
    "asin": "B0HP5ZMCCN",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 928)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100924AURGEN929",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-929",
    "asin": "B0HP5TNFXJ",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 929)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100925AURGEN930",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-930",
    "asin": "B0HP5WV91V",
    "name": "Kitchen Storage Cabinet – Heavy-Duty Multi-Tier Storage Organizer Shelf",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100926AURGEN931",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-931",
    "asin": "B0HP624RDL",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 931)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100927AURGEN932",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-932",
    "asin": "B0HP5RGK8P",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 932)",
    "price": 43.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100928AURGEN933",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-933",
    "asin": "B0HP5RT2JT",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 933)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100929AURGEN934",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-934",
    "asin": "B0HP5RGYXB",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 934)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100930AURGEN935",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-935",
    "asin": "B0HP63JL6S",
    "name": "Shoe Storage Cabine – Rustproof Corner Shower & Vanity Storage Shelf Rack (Quick-Dry Ventilated Design · 935 Series)",
    "price": 63.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100931AURGEN936",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-936",
    "asin": "B0HP5ZGVR7",
    "name": "Electric Window Regulator Rear Left Fit For Tahoe/yukon 00-06 – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100932AURGEN937",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-937",
    "asin": "B0HP5S4NYB",
    "name": "Electric Motorcycle Children Electric Motorcycle With Support Wheels, Lithium – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100933AURGEN938",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-938",
    "asin": "B0HP5PKHF7",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 938)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100934AURGEN939",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-939",
    "asin": "B0HP5RWWBJ",
    "name": "Rustproof Matte Black Corner Shower & Vanity Storage Shelf Caddy (Series 939)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100935AURGEN940",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-940",
    "asin": "B0HP5S18YM",
    "name": "Gray Mobile Kitchen Island Cart With Drop-leaf Design, Lockable – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100936AURGEN941",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-941",
    "asin": "B0HP63JDBR",
    "name": "70 Narrow Tall Bathroom Storage Cabinet, Slim Freestanding Design – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100937AURGEN942",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-942",
    "asin": "Pending ASIN",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 942)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100938AURGEN943",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-943",
    "asin": "B0HP5X2YQQ",
    "name": "Full-flannel Electric Heating Blanket, With 10 Heating Levels, Featuring – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100939AURGEN944",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-944",
    "asin": "B0HP5Z2W1F",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 944)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100940AURGEN945",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-945",
    "asin": "B0HP5RCXWW",
    "name": "67 White 4-door Kitchen Pantry With Drawer And Adjustable – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100941AURGEN946",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-946",
    "asin": "B0HP5TXJKT",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 946)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100942AURGEN947",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-947",
    "asin": "B0HP5ZCV9C",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 947)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100943AURGEN948",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-948",
    "asin": "B0HP6182P5",
    "name": "Twin-dual Heating Mattress Pad Ultra Wide Dual Controller Electric – Rapid-Heating Insulated Electric Water Boiler Kettle",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100944AURGEN949",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-949",
    "asin": "B0HP5PDSL2",
    "name": "7-layer Shoe Rack – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100945AURGEN950",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-950",
    "asin": "B0HP5X2GSD",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 950)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100946AURGEN951",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-951",
    "asin": "B0HP5R9P31",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 951)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100947AURGEN952",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-952",
    "asin": "B0HP5Z92XY",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 952)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100948AURGEN953",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-953",
    "asin": "B0HP5RQ2R5",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 953)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100949AURGEN954",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-954",
    "asin": "B0HP5ZJGFN",
    "name": "Witch 62, Riding Broom, Halloween Electric Doll, Eyes Glowing – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100950AURGEN955",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-955",
    "asin": "B0HP5VJBYH",
    "name": "Cifbuy Vintage Deer Antler Wall Mounted Coat Rack With",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100951AURGEN956",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-956",
    "asin": "B0HP5PRD71",
    "name": "Herbal Teeth Cleaning 40g Stain Removal Fresh Breath Gum – High-Density Bristle Dish & Tile Cleaning Brush",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100952AURGEN957",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-957",
    "asin": "B0HP5ZG8BF",
    "name": "Herbal Tea Bag Body Treatment Oil Cleaning – Non-Scratch Pot, Pan & Sink Scrubbing Cleaning Brush",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100953AURGEN958",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-958",
    "asin": "B0HP5X6CHJ",
    "name": "Plate Drain Rack With Layers – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 44.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100954AURGEN959",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-959",
    "asin": "B0HP5YYVN2",
    "name": "King-heating Mattress Pad-super Wide Dual-control Electric Heating Pad With – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100955AURGEN960",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-960",
    "asin": "B0HP5RVWCC",
    "name": "Skin Gel 30g Cleansing Daily Moisturizer Hand And Body – Deep Tissue Muscle Recovery & Relaxation Massager",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100956AURGEN961",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-961",
    "asin": "B0HP5X9MNN",
    "name": "Precision Gooseneck Pour-Over Electric Tea & Coffee Water Boiler Kettle (Series 961)",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100957AURGEN962",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-962",
    "asin": "Pending ASIN",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 962)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100958AURGEN963",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-963",
    "asin": "B0HP65Y4K8",
    "name": "Multi-Angle Deep-Kneading Leg, Calf & Foot Relaxation Roller Massager (Edition 963)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100959AURGEN964",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-964",
    "asin": "B0HP5RCN2N",
    "name": "Cifbuy Gothic Style Metal Wall Hooks, Vintage Industrial Heavy – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100960AURGEN965",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-965",
    "asin": "B0HP5RL6BC",
    "name": "Cifbuy Black Metal Wall Hook Rack Minimalist Rustproof Iron",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100961AURGEN966",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-966",
    "asin": "B0HP6182P4",
    "name": "Dual-Ended Tile Joint, Faucet Base & Shower Door Track Detail Brush (Model 966)",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100962AURGEN967",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-967",
    "asin": "B0HP5PN4RC",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 967)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100963AURGEN968",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-968",
    "asin": "B0HP5VK4NK",
    "name": "1pc Electric Window Regulator W/o Motor Fit For Bmw – Fast-Boil Cordless Electric Kettle & Hot Water Boiler",
    "price": 35.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100964AURGEN969",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-969",
    "asin": "B0HP5XFL7Z",
    "name": "W882 Outdoor Portable Product Battery Display 1200mah Electric Mosquito – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100965AURGEN970",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-970",
    "asin": "B0HP5YZYGP",
    "name": "Rapid-Boil Double-Wall Insulated Countertop Electric Hot Water Kettle (Series 970)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100966AURGEN971",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-971",
    "asin": "B0HP5S45SN",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 971)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100967AURGEN972",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-972",
    "asin": "B0HP63J8XZ",
    "name": "Clothing Rack, Golden Metal Freestanding Heavy Duty Clothes Rack",
    "price": 89.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100968AURGEN973",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-973",
    "asin": "B0HP5WYH4K",
    "name": "Balm 30g Daily Moisturizer Hand And Body Care Skin – Handheld Skin Toning & Target Points Body Massager",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100969AURGEN974",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-974",
    "asin": "B0HP5PF6G8",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 974)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100970AURGEN975",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-975",
    "asin": "B0HP5VDMWB",
    "name": "W7104 Outdoor Portable Product Solar Powered Motion Sensor Electric – Compact Travel & Office Fast-Boil Electric Water Kettle",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100971AURGEN976",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-976",
    "asin": "B0HP64M1P1",
    "name": "Potting Bench With Storage Cabinet And Metal Table Top – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 60.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100972AURGEN977",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-977",
    "asin": "B0HP5YXKWB",
    "name": "Ergonomic Long-Handle Kitchen Sink, Pot & Cast-Iron Dish Scrubber Brush (Model 977)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100973AURGEN978",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-978",
    "asin": "Pending ASIN",
    "name": "Multi-Surface Crevice & Window Sliding Track Deep Cleaning Brush Set (Model 978)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100974AURGEN979",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-979",
    "asin": "B0HP5XJGV4",
    "name": "Body Deodorant 15g Deodorizing With Rose Daily Skin Treat – Contoured Trigger-Point & Myofascial Release Massager",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100975AURGEN980",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-980",
    "asin": "B0HP5S5YRG",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 980)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100976AURGEN981",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-981",
    "asin": "Pending ASIN",
    "name": "1.7L Fast-Boil Stainless & Borosilicate Cordless Electric Kettle (981 Pro Series)",
    "price": 32.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100977AURGEN982",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-982",
    "asin": "B0HP5PTL8B",
    "name": "Portable Dual-Node Cervical Neck & Upper Back Kneading Roller Tool (Edition 982)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100978AURGEN983",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-983",
    "asin": "B0HP636F1Q",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 983)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100979AURGEN984",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-984",
    "asin": "B0HP5PJZN2",
    "name": "Cube Open Storage Bookshelf With Heavy-duty Metal Elevated Legs, – Wall-Mounted Storage Shelf Organizer Rack",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100980AURGEN985",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-985",
    "asin": "B0HP5RFV19",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 985)",
    "price": 47.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100981AURGEN986",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-986",
    "asin": "B0HP6837PP",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 986)",
    "price": 39.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100982AURGEN987",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-987",
    "asin": "B0HP5Z2W1L",
    "name": "Cifbuy Rustic Farmhouse Wall Mounted Mug Rack, Space-saving Coffee",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100983AURGEN988",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-988",
    "asin": "B0HP666PWP",
    "name": "Cifbuy Sleek Black Metal Wall Hooks With Cat Design, – Modular Kitchen & Bathroom Storage Shelf Organizer",
    "price": 24.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100984AURGEN989",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-989",
    "asin": "B0HP5V91TG",
    "name": "183cm Half Foldable Plastic Folding Table With Handle, Portable – Freestanding Countertop Display & Storage Shelf Rack",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100985AURGEN990",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-990",
    "asin": "B0HP5ZYRQV",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 990)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100986AURGEN991",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-991",
    "asin": "Pending ASIN",
    "name": "Extended-Reach Bathtub, Floor Tile & Patio Grout Scrubbing Brush (Model 991)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100987AURGEN992",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-992",
    "asin": "B0HP635F8S",
    "name": "Heavy-Duty Stiff-Bristle Tile Grout & Shower Track Scrubbing Brush (Model 992)",
    "price": 45.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100988AURGEN993",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-993",
    "asin": "B0HP5TZTQ6",
    "name": "Kids Electric Car 12v Kids Car With Remote Control – Stainless Steel & Borosilicate Glass Electric Tea Kettle",
    "price": 69.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100989AURGEN994",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-994",
    "asin": "B0HP61LCS7",
    "name": "Kids Electric Car 12v Kids Car With Remote Control – Precision Pour-Over Gooseneck Electric Water Kettle",
    "price": 29.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100990AURGEN995",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-995",
    "asin": "B0HP5ZJRGH",
    "name": "360-Degree Rotary Bottle, Carafe & Narrow-Neck Tumbler Cleaning Brush (Model 995)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100991AURGEN996",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-996",
    "asin": "B0HP5XK5ZV",
    "name": "Contoured Handheld Myofascial Release & Muscle Recovery Body Massager (Edition 996)",
    "price": 41.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100992AURGEN997",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-997",
    "asin": "B0HP5PJZN7",
    "name": "Power Steering Pump Fit For Toyota Rav4 L4 0l – Double-Wall Cool-Touch Cordless Electric Water Kettle",
    "price": 38.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100993AURGEN998",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-998",
    "asin": "B0HP5TQ1TP",
    "name": "Mint Teeth Cleaning Powder 50g Stain Removal Fresh Breath – 360-Degree Rotary Household & Bottle Cleaning Brush",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100994AURGEN999",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-999",
    "asin": "B0HP613NT8",
    "name": "Compact Handheld Percussion & Soothing Warmth Muscle Relaxation Tool (Edition 999)",
    "price": 61.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100995AURGEN1000",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-1000",
    "asin": "B0HP5X6NY4",
    "name": "Heavy-Duty Multi-Tier Countertop & Under-Sink Storage Organizer Shelf (Series 1000)",
    "price": 48.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100996AURGEN1001",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-1001",
    "asin": "B0HP5PCWNK",
    "name": "18 12 14 Inch Underbody Truck Storage Box Diamond – Space-Saving Countertop & Cabinet Storage Shelf Rack",
    "price": 51.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100997AURGEN1002",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-1002",
    "asin": "B0HP5TYTD9",
    "name": "Space-Saving Freestanding Pantry, Closet & Cabinet Shelf Riser Rack (Series 1002)",
    "price": 54.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100998AURGEN1003",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-04 · Electric Tea Kettles & Boilers",
    "sku": "AUR-GEN-1003",
    "asin": "B0HP65TWP9",
    "name": "Electric Motorcycle Children Electric Motorcycle With Support Wheels, Lithium – Auto Shut-Off Countertop Electric Hot Water Kettle",
    "price": 57.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016100999AURGEN1004",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-01 · Cleaning Brushes & Scrubbers",
    "sku": "AUR-GEN-1004",
    "asin": "Pending ASIN",
    "name": "Angled Corner & Baseboard Seam Heavy-Duty Household Scrub Brush (Model 1004)",
    "price": 52.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016101000AURGEN1005",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-03 · Massagers & Recovery Wellness",
    "sku": "AUR-GEN-1005",
    "asin": "B0HP5V3M4J",
    "name": "Ergonomic Deep-Tissue Trigger-Point Neck, Shoulder & Back Roller Massager (Edition 1005)",
    "price": 42.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  },
  {
    "date": "2026-10-24",
    "adId": "A016101001AURGEN1006",
    "campaign": "Aurelius SP - All-Catalog Low-Bid Catch-All Auto",
    "adGroup": "AG-02 · Bathroom & Kitchen Shelves",
    "sku": "AUR-GEN-1006",
    "asin": "B0HP5V513X",
    "name": "Kids Pink Foot-to-floor Push Car Horn, Light Music, Anti-tip – Over-Sink & Cabinet Door Hanging Storage Shelf Organizer",
    "price": 66.99,
    "state": "ENABLED",
    "status": "AD_STATUS_LIVE",
    "impressions": 0,
    "clicks": 0,
    "spend": 0,
    "sales": 0,
    "orders": 0,
    "units": 0
  }
];
